var _polygon, _polygon2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatientDetail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-28",
    d: "M77.38,233.51c-95.33,55-95.33,144.28,0,199.32s249.9,55,345.23,0,95.33-144.28,0-199.32S172.71,178.47,77.38,233.51Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frame--inject-28"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "381.33 65.69 379.41 66.76 379.41 138.61 381.33 137.54 381.33 65.69",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.33 137.54 381.34 67.87 458.45 112.39 458.44 182.06 381.33 137.54",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462,190.42V110.33L375.85,60.58v80.09Zm-82.61-51.81V66.76l79,45.63v71.86Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.41 138.61 381.33 137.54 458.44 182.06 458.45 184.25 379.41 138.61",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.94 79.19 399.02 78.08 399.02 149.93 400.94 148.86 400.94 79.19",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.26 104.2 442.34 103.09 442.34 174.94 444.26 173.87 444.26 104.2",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462.02 190.42 463.93 189.31 463.93 109.22 462.02 110.33 462.02 190.42",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.93 109.22 462.02 110.33 375.85 60.58 377.76 59.47 463.93 109.22",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "458.45 144.6 458.45 146.81 379.41 101.18 381.32 100.06 458.45 144.6",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "458.44 150.93 458.45 146.81 379.41 101.18 379.41 105.3 458.44 150.93",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.34 179.06 438.78 177 438.78 96.92 442.34 98.97 442.34 179.06",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.03 154.05 395.47 152 395.47 71.91 399.03 73.97 399.03 154.05",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.34 137.51 444.26 136.4 444.26 104.2 442.34 103.09 442.34 137.51",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.04 112.51 400.96 111.4 400.96 79.2 399.04 78.09 399.04 112.51",
    style: {
      fill: "#fafafa"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clock--inject-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clock--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M244.33,46.16h0l-5-2.89h0l0,0h0c-3.14-1.6-7.34-1.13-11.85,1.78-9.08,5.84-16,19.32-15.48,30.1.26,5.37,2.32,9.06,5.45,10.68h0l0,0h0l5,2.89h0l0,0h0c3.14,1.59,7.34,1.13,11.86-1.79,9.07-5.84,16-19.31,15.48-30.09C249.52,51.48,247.46,47.79,244.33,46.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.18,88.59l-4.76-2.77h0l0,0c-3.13-1.63-5.19-5.32-5.45-10.68A33.58,33.58,0,0,1,215.21,60l5,2.89A33.6,33.6,0,0,0,216.92,78C217.18,83.26,219.16,86.91,222.18,88.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.3,86.94c9.07-5.84,16-19.31,15.48-30.09s-8.3-14.78-17.37-8.94-16,19.32-15.48,30.1S225.23,92.79,234.3,86.94Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.7,86.19c-5.35.26-6.22-5.75-6.35-8.35-.46-9.51,5.91-21.89,13.91-27A12.26,12.26,0,0,1,240,48.66c5.35-.26,6.22,5.76,6.34,8.36.47,9.5-5.9,21.89-13.91,27a12.06,12.06,0,0,1-5.74,2.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.4,69.21l-.19,0a.58.58,0,0,1-.39-.55V54.87a.58.58,0,0,1,.58-.58.59.59,0,0,1,.59.58V66.93l6.41-8.24a.58.58,0,0,1,.92.72L234.86,69A.58.58,0,0,1,234.4,69.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.12,79.37H231a.25.25,0,0,1-.17-.31l3.23-10.87a.24.24,0,0,1,.3-.17.25.25,0,0,1,.17.3l-3.23,10.88A.24.24,0,0,1,231.12,79.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.22,65.88c1.07-.69,2-.22,2,1.05a4.4,4.4,0,0,1-1.82,3.54c-1.07.69-2,.22-2-1A4.4,4.4,0,0,1,234.22,65.88Z",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Buttons--inject-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--buttons--inject-28"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "95.53 136.59 97.19 137.54 116.26 130.36 181.15 92.9 193.58 81.88 191.93 80.93 95.53 136.59",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.53 136.59 97.19 137.54 97.19 147.57 95.53 146.62 95.53 136.59",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.26 130.36 116.26 140.4 97.19 147.57 97.19 137.54 116.26 130.36",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.15 92.9 193.58 81.88 193.58 91.92 181.15 102.93 116.26 140.4 116.26 130.36 181.15 92.9",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.16 133.56 119.8 136.08 119.8 130.27 124.16 127.75 124.16 133.56",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.16 133.56 119.8 136.08 119.8 130.27 124.16 127.75 124.16 133.56",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.69 129.22 127.33 131.73 127.33 125.92 131.69 123.41 131.69 129.22",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.69 129.22 127.33 131.73 127.33 125.92 131.69 123.41 131.69 129.22",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.23 124.87 134.87 127.39 134.87 121.58 139.23 119.06 139.23 124.87",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.76 120.52 142.4 123.04 142.4 117.23 146.76 114.71 146.76 120.52",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.29 116.18 149.94 118.69 149.94 112.88 154.29 110.37 154.29 116.18",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.83 111.83 157.47 114.34 157.47 108.53 161.83 106.02 161.83 111.83",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.36 107.48 165 110 165 104.19 169.36 101.67 169.36 107.48",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.36 107.48 165 110 165 104.19 169.36 101.67 169.36 107.48",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.89 103.14 172.54 105.65 172.54 99.84 176.89 97.33 176.89 103.14",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-28",
    d: "M319.61,217.87c-8.72,5-8.72,13.21,0,18.25s22.88,5,31.61,0,8.72-13.21,0-18.25S328.34,212.83,319.61,217.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-28",
    d: "M368.43,222.27l102,59a.8.8,0,0,1,0,1.52l-29.19,16.84a2.88,2.88,0,0,1-2.62,0l-102-59a.8.8,0,0,1,0-1.51l29.19-16.84A2.88,2.88,0,0,1,368.43,222.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-28",
    d: "M52,323.75,275.08,452.57a5.76,5.76,0,0,0,5.21,0L397.4,385c1.44-.84,1.44-2.18,0-3L174.28,253.13a5.78,5.78,0,0,0-5.22,0L52,320.74C50.52,321.57,50.52,322.92,52,323.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-28",
    d: "M375.48,366.22l-137.1,79.29a5.61,5.61,0,0,1-5.11,0l-41.4-23.91c-1.41-.82-1.41-2.14,0-3L329,339.36a5.66,5.66,0,0,1,5.1,0l41.41,23.92C376.89,364.09,376.89,365.41,375.48,366.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-28",
    cx: 51.87,
    cy: 364.52,
    rx: 32.95,
    ry: 19.02,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-28",
    d: "M300.12,226.06l-43.26-25-49.27,28.45,43.36,25a8.44,8.44,0,0,0,7.63,0l41.54-24.09C302.23,229.25,302.22,227.27,300.12,226.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.51,400.92c4.28,2.07,3.34,5,0,7.79s-8.54,4.23-10.95,6.91-5.86,7.68-13.77,7.68-14.56-3.07-11.11-7,7.21-5.06,13-7.51,9.19-5.34,12.95-7.27C162.81,399.92,165.84,399.13,169.51,400.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.82,393.05c-3.6-2.47-8.68-1.93-13.51,0s-7.33,4.93-12,6.33-9.86,2.52-11.42,7.66c-1.31,4.37,4.45,8.47,10.08,7.26,4.87-1.05,8.87-4.73,13.11-8.07s9.24-5.31,12.59-7.48C148.53,396.92,149.9,395.17,146.82,393.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lamp--inject-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--lamp--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.22,223.05h0c0-2.63-1.73-5.26-5.2-7.27-7-4-18.23-4-25.19,0-3.48,2-5.2,4.64-5.2,7.27h0v2.46h0c0,2.6,1.78,5.19,5.21,7.17,7,4,18.23,4,25.19,0,3.43-2,5.17-4.57,5.21-7.17h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.82,215.78c-6.95,4-6.95,10.53,0,14.54s18.23,4,25.19,0,6.95-10.52,0-14.54S329.78,211.77,322.82,215.78Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.33,80.16H333.5V221.9h0a.9.9,0,0,0,.55.88,3,3,0,0,0,2.71,0,.9.9,0,0,0,.55-.88h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.91,86.23h0L346.4,62H324.34L317.9,86.23h0c-1.17,3.21.44,6.68,4.86,9.17,7,3.93,18.3,3.93,25.29,0C352.48,92.91,354.09,89.44,352.91,86.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.59,67.16a17.71,17.71,0,0,0,15.65,0c4.32-2.44,4.32-6.39,0-8.82a17.64,17.64,0,0,0-15.65,0C323.26,60.77,323.26,64.72,327.59,67.16Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.41,67.45a14.06,14.06,0,0,1-6.78-1.57c-1.58-.89-2.45-2-2.45-3.13s.87-2.25,2.45-3.14a15.45,15.45,0,0,1,13.57,0c1.58.89,2.45,2,2.45,3.14s-.87,2.24-2.45,3.13A14.1,14.1,0,0,1,335.41,67.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Furniture--inject-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.66,289.28h-6.21l1,6.05h0a1.12,1.12,0,0,0,.6.75,3.3,3.3,0,0,0,3,0,1.14,1.14,0,0,0,.61-.75h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.66,289.28h-6.21l1,6.05h0a1.12,1.12,0,0,0,.6.75,3.3,3.3,0,0,0,3,0,1.14,1.14,0,0,0,.61-.75h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.11,238.19h-6.2l1,6.05h0a1.12,1.12,0,0,0,.6.75,3.31,3.31,0,0,0,3,0,1.09,1.09,0,0,0,.6-.75h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.11,238.19h-6.2l1,6.05h0a1.12,1.12,0,0,0,.6.75,3.31,3.31,0,0,0,3,0,1.09,1.09,0,0,0,.6-.75h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.86,274.7h-6.2l1,6.05h0a1.14,1.14,0,0,0,.6.75,3.37,3.37,0,0,0,3,0,1.11,1.11,0,0,0,.6-.75h0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.86,274.7h-6.2l1,6.05h0a1.14,1.14,0,0,0,.6.75,3.37,3.37,0,0,0,3,0,1.11,1.11,0,0,0,.6-.75h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "468.39 209.13 468.39 277.37 438.52 294.66 438.52 226.41 468.39 209.13",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.52 294.66 343.17 239.64 343.17 171.4 438.52 226.41 438.52 294.66",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "409.44 277.87 408.22 277.16 408.22 208.92 409.44 209.63 409.44 277.87",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.85 253.86 366.63 253.15 366.63 184.91 367.85 185.62 367.85 253.86",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.94,171.81a.92.92,0,0,1,.54-.76l31.92-18.46a2.88,2.88,0,0,1,2.62,0l96.72,55.79a.91.91,0,0,1,.55.76v1.73a.91.91,0,0,1-.55.76l-31.92,18.46a2.88,2.88,0,0,1-2.62,0l-96.72-55.81a.92.92,0,0,1-.54-.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.29,209.14v1.73a.91.91,0,0,1-.55.76l-31.92,18.46a2.64,2.64,0,0,1-1.3.32v-11L442,191.21l29.75,17.17A.91.91,0,0,1,472.29,209.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,152.59l96.72,55.79a.79.79,0,0,1,0,1.51l-31.92,18.46a2.88,2.88,0,0,1-2.62,0l-96.72-55.79a.8.8,0,0,1,0-1.51l31.92-18.46A2.88,2.88,0,0,1,375,152.59Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,152.59l96.72,55.79a.79.79,0,0,1,0,1.51l-31.92,18.46a2.88,2.88,0,0,1-2.62,0l-96.72-55.79a.8.8,0,0,1,0-1.51l31.92-18.46A2.88,2.88,0,0,1,375,152.59Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.71,153.28a1.73,1.73,0,0,1,.81.18l96.53,55.68-31.73,18.35a1.7,1.7,0,0,1-.81.18,1.76,1.76,0,0,1-.81-.18l-96.53-55.68,31.73-18.35a1.73,1.73,0,0,1,.81-.18m0-1a2.67,2.67,0,0,0-1.31.31l-31.92,18.46a.8.8,0,0,0,0,1.51l96.72,55.79a2.7,2.7,0,0,0,1.31.32,2.65,2.65,0,0,0,1.31-.32l31.92-18.46a.79.79,0,0,0,0-1.51L375,152.59a2.67,2.67,0,0,0-1.31-.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.22,231.22c0,.42-1.26,0-2.81-.86l-3.71-2.14c-1.55-.9-2.81-2-2.81-2.39v-.76l9.33,5.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.87,192.36c0,.42-1.26,0-2.81-.86l-3.71-2.13c-1.55-.9-2.81-2-2.81-2.4v-.76l9.33,5.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.16,216c0,.42-1.26,0-2.81-.86L386.64,213c-1.55-.9-2.81-2-2.81-2.4v-.76l9.33,5.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.16,232.17c0,.42-1.26,0-2.81-.87l-3.71-2.13c-1.55-.9-2.81-2-2.81-2.39V226l9.33,5.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.16,255.38c0,.42-1.26,0-2.81-.86l-3.71-2.14c-1.55-.89-2.81-2-2.81-2.39v-.76l9.33,5.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.24 211.06 409.03 235.18 409.03 236.53 367.24 212.4 367.24 211.06",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.25 234.27 409.03 258.39 409.03 259.74 367.25 235.62 367.25 234.27",
    style: {
      fill: "#e6e6e6"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--night-table--inject-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--side-table--inject-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--side-table--inject-28"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "291.73 231.16 284.47 226.96 291.73 224.86 291.73 231.16",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.73 231.16 284.47 226.96 291.73 224.86 291.73 231.16",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.73 231.16 284.47 226.96 291.73 224.86 291.73 231.16",
    style: {
      fill: "#845EC2",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.73 231.16 295.37 229.06 295.37 222.77 291.73 224.86 291.73 231.16",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.73 231.16 295.37 229.06 295.37 222.77 291.73 224.86 291.73 231.16",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.34 245.88 255.34 252.57 212.33 227.69 212.33 221.01 255.34 245.88",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.34 245.88 255.34 252.57 212.33 227.69 212.33 221.01 255.34 245.88",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.34 245.88 255.34 252.57 212.33 227.69 212.33 221.01 255.34 245.88",
    style: {
      fill: "#845EC2",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.34 252.57 258.97 250.47 258.97 243.78 255.34 245.88 255.34 252.57",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.34 252.57 258.97 250.47 258.97 243.78 255.34 245.88 255.34 252.57",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.7 168.57 251.71 193.44 251.71 247.97 208.7 223.1 208.7 168.57",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.7 168.57 251.71 193.44 251.71 247.97 208.7 223.1 208.7 168.57",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.71 193.44 299 166.13 299 220.67 251.71 247.97 251.71 193.44",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.71 193.44 299 166.13 299 220.67 251.71 247.97 251.71 193.44",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299 166.13 255.99 141.26 208.7 168.57 251.71 193.44 299 166.13",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299 166.13 255.99 141.26 208.7 168.57 251.71 193.44 299 166.13",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.1 159.13 241.78 152.58 215.86 167.54 227.18 174.09 253.1 159.13",
    style: {
      fill: "#845EC2",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.34 212.32 295.37 189.21 295.37 218.57 255.34 241.68 255.34 212.32",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.34 212.32 295.37 189.21 295.37 218.57 255.34 241.68 255.34 212.32",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.37 218.57 270.11 203.79 255.34 212.32 255.34 241.68 295.37 218.57",
    style: {
      fill: "#845EC2",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.37 218.57 270.11 203.79 295.37 189.21 295.37 218.57",
    style: {
      fill: "#845EC2",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.34 195.54 295.37 172.43 295.37 185.01 255.34 208.12 255.34 195.54",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.34 195.54 295.37 172.43 295.37 185.01 255.34 208.12 255.34 195.54",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.75,191c0,.58,1.73,0,3.87-1.18l6.78-3.92c2.14-1.23,3.88-2.71,3.88-3.28v-1L267.75,190Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-28",
    d: "M276.75,164.4c3.41,2,3.41,5.15,0,7.12a13.66,13.66,0,0,1-12.33,0c-3.41-2-3.41-5.16,0-7.12A13.6,13.6,0,0,1,276.75,164.4Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,169.36c-3-3-4.71-10.59-1.81-13H278c2.89,2.4,1.15,10-1.82,13l-.08.09a.94.94,0,0,1-.1.1l-.27.24-.07.05a1.84,1.84,0,0,1-.22.17l-.38.25a9.83,9.83,0,0,1-8.84,0h0l-.39-.25-.21-.16-.08-.07-.26-.23-.12-.11Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.67,155.22c3.36,1.94,3.36,5.08,0,7a13.43,13.43,0,0,1-12.16,0c-3.36-1.93-3.36-5.08,0-7A13.43,13.43,0,0,1,276.67,155.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.29,156.6c2,1.18,2,3.09,0,4.27a8.18,8.18,0,0,1-7.4,0c-2.05-1.18-2.05-3.09,0-4.27A8.18,8.18,0,0,1,274.29,156.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.89,158.62a8.18,8.18,0,0,1,7.4,0,3.37,3.37,0,0,1,1.22,1.13,3.35,3.35,0,0,1-1.22,1.12,8.18,8.18,0,0,1-7.4,0,3.47,3.47,0,0,1-1.23-1.12A3.49,3.49,0,0,1,266.89,158.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.84,159.75a16.89,16.89,0,0,0,2.67-3.56c1.24-2.19,1.47-5.12.83-5.48s-3.24,2.56-3.24,2.56a15.87,15.87,0,0,0,.27-3.73c-.11-1.94-.58-3.71-1.14-4.07s-1.8,2.1-2.34,3.88-.85,3.24-.85,3.24a28.45,28.45,0,0,0-1-4.1c-.65-1.84-1.24-2.26-1.7-2.08s-.75,1.05-.89,3.51a25,25,0,0,0,.11,3.52s-.91-1-1.93-2-1.6-1.22-1.92-1-.41,1.87,1.33,5a17.35,17.35,0,0,0,3.26,4.31S269.74,161.29,273.84,159.75Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.84,159.75a16.89,16.89,0,0,0,2.67-3.56c1.24-2.19,1.47-5.12.83-5.48s-3.24,2.56-3.24,2.56a15.87,15.87,0,0,0,.27-3.73c-.11-1.94-.58-3.71-1.14-4.07s-1.8,2.1-2.34,3.88-.85,3.24-.85,3.24a28.45,28.45,0,0,0-1-4.1c-.65-1.84-1.24-2.26-1.7-2.08s-.75,1.05-.89,3.51a25,25,0,0,0,.11,3.52s-.91-1-1.93-2-1.6-1.22-1.92-1-.41,1.87,1.33,5a17.35,17.35,0,0,0,3.26,4.31S269.74,161.29,273.84,159.75Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-28"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "228.38 169.5 229.47 170.04 249.86 158.46 248.77 157.92 228.38 169.5",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.77 157.92 229.37 168.94 226.76 140.01 246.16 129 248.77 157.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.85,125.32,224.7,139l3.08,34.11,24.14-13.72Zm1,33.14L229.47,170l-2.71-30,20.4-11.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.86 158.46 248.77 157.92 246.16 129 247.16 128.43 249.86 158.46",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.85 125.32 247.74 124.8 223.59 138.52 224.7 139.04 248.85 125.32",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.59 138.52 224.7 139.04 227.78 173.15 226.67 172.63 223.59 138.52",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Land--inject-28"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "247.92 157.36 230.04 167.52 229.6 162.65 233.01 148.37 236.14 153.27 235.45 157.38 240.83 142.24 247.49 152.49 247.92 157.36",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.78,142.35a2.5,2.5,0,0,0-1.19,2.19c.07.8.72,1.11,1.45.69a2.5,2.5,0,0,0,1.19-2.19C234.16,142.24,233.51,141.93,232.78,142.35Z",
    style: {
      fill: "#845EC2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--land--inject-28",
    style: {
      opacity: 0.65
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "247.92 157.36 230.04 167.52 229.6 162.65 233.01 148.37 236.14 153.27 235.45 157.38 240.83 142.24 247.49 152.49 247.92 157.36",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.78,142.35a2.5,2.5,0,0,0-1.19,2.19c.07.8.72,1.11,1.45.69a2.5,2.5,0,0,0,1.19-2.19C234.16,142.24,233.51,141.93,232.78,142.35Z",
    style: {
      fill: "#fff"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.69,426.06a16.37,16.37,0,0,1-1.63,7.5c-.35.69-.73,1.34-.95,1.8-.47,1-.1,1.29.52.86.9-.62,5.52-7.14,7.32-13.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.26,437.56a7.61,7.61,0,0,1,3.41-6,2.33,2.33,0,0,1,2.52-.2h0l2.34,1.31-4.89,8.44-2.32-1.31h0A2.4,2.4,0,0,1,231.26,437.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.09,432.94a7.63,7.63,0,0,0-3.41,6c0,2.2,1.57,3.08,3.46,2a7.59,7.59,0,0,0,3.41-6C240.54,432.71,239,431.83,237.09,432.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.28,436.24c0-.86-.53-1.25-1.17-.87A2.77,2.77,0,0,0,236,437.6c0,.86.53,1.25,1.18.88A2.8,2.8,0,0,0,238.28,436.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.11,427.44a16.34,16.34,0,0,1-1.63,7.49c-.35.7-.73,1.34-.95,1.8-.47,1-.1,1.29.52.87.9-.62,5.52-7.14,7.32-13.21Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,436.48a.77.77,0,0,0-.37.58c0,.22.14.31.33.21a.75.75,0,0,0,.38-.57C237.38,436.48,237.23,436.39,237,436.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.51,405.74a16.53,16.53,0,0,1-1.63,7.5c-.35.69-.73,1.34-.95,1.8-.47,1-.1,1.29.52.86.9-.62,5.52-7.14,7.32-13.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.08,417.24a7.61,7.61,0,0,1,3.41-6,2.33,2.33,0,0,1,2.52-.2h0l2.34,1.31-4.9,8.44-2.31-1.32h0A2.4,2.4,0,0,1,196.08,417.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.91,412.62a7.63,7.63,0,0,0-3.41,6c0,2.2,1.56,3.08,3.46,2a7.59,7.59,0,0,0,3.41-6C205.36,412.39,203.81,411.51,201.91,412.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.1,415.92c0-.86-.53-1.25-1.17-.87a2.77,2.77,0,0,0-1.16,2.23c0,.86.53,1.25,1.18.88A2.82,2.82,0,0,0,203.1,415.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.93,407.12a16.34,16.34,0,0,1-1.63,7.49c-.35.7-.73,1.34-1,1.8-.47,1-.1,1.29.52.87.9-.62,5.52-7.14,7.32-13.21Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.85,416.16a.77.77,0,0,0-.37.58c0,.22.13.31.33.21a.75.75,0,0,0,.38-.57C202.2,416.16,202.05,416.07,201.85,416.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.19,357.2a16.37,16.37,0,0,1-1.63,7.5c-.35.69-.73,1.34-.95,1.8-.47,1-.1,1.29.52.86.9-.62,5.52-7.14,7.32-13.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.76,368.7a7.61,7.61,0,0,1,3.41-6,2.33,2.33,0,0,1,2.52-.2h0l2.34,1.31-4.89,8.44L351.82,371h0A2.4,2.4,0,0,1,350.76,368.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.59,364.08a7.66,7.66,0,0,0-3.41,6c0,2.2,1.57,3.08,3.46,2a7.59,7.59,0,0,0,3.41-6C360,363.85,358.49,363,356.59,364.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.78,367.38c0-.86-.53-1.25-1.17-.87a2.76,2.76,0,0,0-1.15,2.23c0,.86.53,1.25,1.17.88A2.8,2.8,0,0,0,357.78,367.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.61,358.58a16.34,16.34,0,0,1-1.63,7.49c-.35.7-.73,1.34-1,1.8-.47,1-.1,1.29.52.87.9-.62,5.52-7.14,7.32-13.21Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.54,367.62a.76.76,0,0,0-.38.58c0,.22.14.31.33.21a.72.72,0,0,0,.38-.57C356.88,367.62,356.73,367.53,356.54,367.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,336.88a16.37,16.37,0,0,1-1.63,7.5c-.35.69-.73,1.34-.95,1.8-.47,1-.1,1.29.52.86.9-.62,5.52-7.14,7.32-13.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.58,348.38a7.61,7.61,0,0,1,3.41-6,2.33,2.33,0,0,1,2.52-.2h0l2.34,1.31L319,351.94l-2.32-1.31h0A2.4,2.4,0,0,1,315.58,348.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.41,343.76a7.66,7.66,0,0,0-3.41,6c0,2.2,1.57,3.08,3.46,2a7.59,7.59,0,0,0,3.41-6C324.86,343.53,323.31,342.65,321.41,343.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.6,347.06c0-.86-.53-1.25-1.17-.87a2.76,2.76,0,0,0-1.15,2.23c0,.86.53,1.25,1.17.88A2.8,2.8,0,0,0,322.6,347.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.43,338.26a16.34,16.34,0,0,1-1.63,7.49c-.35.7-.73,1.34-.95,1.8-.47,1-.1,1.29.52.87.9-.62,5.52-7.14,7.32-13.21Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.36,347.3a.76.76,0,0,0-.38.58c0,.22.14.31.33.21a.72.72,0,0,0,.38-.57C321.7,347.3,321.55,347.21,321.36,347.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,350.73a1.55,1.55,0,0,0-.91-1.25l-33.27-19.21a4.82,4.82,0,0,0-4.39,0L193.81,407.32a1.55,1.55,0,0,0-.92,1.27c0,.46,0,3.69,0,4.14a1.53,1.53,0,0,0,.92,1.3l33.26,19.2a4.81,4.81,0,0,0,4.4,0l133.62-77.05a1.54,1.54,0,0,0,.9-1.27C366,354.45,366,351.2,366,350.73Zm-7.29,2.09L229.26,427.47l-29.1-16.79L329.61,336Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.42,330.26,193.81,407.32c-1.22.7-1.23,1.84,0,2.54l33.26,19.21a4.87,4.87,0,0,0,4.4,0L365.09,352a1.34,1.34,0,0,0,0-2.53l-33.27-19.21A4.82,4.82,0,0,0,327.42,330.26Zm34.89,20.48-133,76.73-32.71-18.88,133.06-76.73Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bed--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.94,404.78a42.17,42.17,0,0,0,4.21,19.29c.9,1.79,1.87,3.46,2.43,4.63,1.22,2.53.26,3.34-1.33,2.24-2.32-1.6-14.21-18.39-18.84-34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.92,434.37c0-5.66-3.89-12.57-8.78-15.43-2.56-1.5-4.87-1.57-6.49-.5h0l-6,3.38,12.59,21.71,6-3.37v0C281.85,439.25,282.9,437.26,282.92,434.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.91,422.48c4.88,2.86,8.81,9.77,8.77,15.43s-4,7.93-8.9,5.07S259,433.21,259,427.55,263,419.62,267.91,422.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.85,431c0-2.22,1.36-3.22,3-2.26a7.19,7.19,0,0,1,3,5.77c0,2.21-1.36,3.22-3,2.25A7.17,7.17,0,0,1,264.85,431Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.71,408.31a42.15,42.15,0,0,0,4.21,19.29c.9,1.8,1.87,3.46,2.43,4.63,1.22,2.54.26,3.34-1.33,2.24-2.32-1.6-14.21-18.39-18.85-34Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.05,431.6a2,2,0,0,1,1,1.48c0,.56-.35.81-.85.56a1.94,1.94,0,0,1-1-1.48C267.17,431.6,267.55,431.35,268.05,431.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.45,350a42.2,42.2,0,0,0,4.21,19.3c.9,1.79,1.87,3.45,2.44,4.63,1.21,2.53.26,3.33-1.34,2.23-2.32-1.6-14.21-18.39-18.84-34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.43,379.57c0-5.66-3.89-12.57-8.78-15.43-2.56-1.5-4.87-1.58-6.49-.5h0l-6,3.37,12.59,21.72,6-3.38h0C376.36,384.45,377.41,382.46,377.43,379.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.42,367.68c4.88,2.86,8.81,9.77,8.78,15.43s-4,7.93-8.91,5.07-8.82-9.77-8.78-15.43S357.53,364.82,362.42,367.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.36,376.17c0-2.21,1.37-3.22,3-2.25a7.22,7.22,0,0,1,3,5.76c0,2.21-1.37,3.22-3,2.25A7.18,7.18,0,0,1,359.36,376.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.22,353.51a42.17,42.17,0,0,0,4.21,19.29c.9,1.79,1.87,3.46,2.43,4.63,1.22,2.54.26,3.34-1.33,2.24-2.32-1.6-14.21-18.39-18.85-34Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.56,376.8a1.93,1.93,0,0,1,1,1.48c0,.56-.35.81-.85.56a2,2,0,0,1-1-1.48C361.68,376.8,362.06,376.55,362.56,376.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.16,314.22a42.24,42.24,0,0,0,4.2,19.29c.91,1.8,1.88,3.46,2.44,4.63,1.21,2.54.26,3.34-1.33,2.24-2.32-1.6-14.22-18.39-18.85-34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.14,343.81c0-5.66-3.9-12.57-8.78-15.43-2.56-1.5-4.87-1.57-6.5-.5h0l-6,3.38L118.45,353l6-3.37v0C126.06,348.69,127.12,346.7,127.14,343.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.12,331.92c4.89,2.87,8.82,9.77,8.78,15.43s-4,7.93-8.91,5.07-8.81-9.77-8.78-15.43S107.24,329.06,112.12,331.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.06,340.42c0-2.21,1.37-3.22,3-2.25a7.18,7.18,0,0,1,3,5.76c0,2.21-1.37,3.22-3,2.25A7.22,7.22,0,0,1,109.06,340.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.93,317.75a42.12,42.12,0,0,0,4.2,19.3c.9,1.79,1.88,3.46,2.44,4.63,1.21,2.53.26,3.33-1.34,2.23-2.32-1.6-14.21-18.38-18.84-34Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.27,341.05a2,2,0,0,1,1,1.47c0,.57-.35.82-.86.56a1.93,1.93,0,0,1-1-1.47C111.38,341,111.77,340.79,112.27,341.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.42,260.2a42.27,42.27,0,0,0,4.2,19.3c.9,1.79,1.88,3.46,2.44,4.63,1.21,2.53.26,3.33-1.34,2.23-2.32-1.6-14.21-18.38-18.84-34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.4,289.8c0-5.66-3.9-12.57-8.78-15.43-2.56-1.5-4.87-1.58-6.5-.5h0l-6,3.38L213.71,299l5.95-3.38h0C221.32,294.68,222.38,292.69,222.4,289.8Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.38,277.91c4.89,2.86,8.82,9.77,8.78,15.43s-4,7.93-8.91,5.07-8.81-9.77-8.78-15.43S202.5,275.05,207.38,277.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.32,286.4c0-2.21,1.37-3.22,3-2.25a7.2,7.2,0,0,1,3,5.76c0,2.22-1.37,3.22-3,2.26A7.23,7.23,0,0,1,204.32,286.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.19,263.74a42.07,42.07,0,0,0,4.2,19.29c.9,1.8,1.88,3.46,2.44,4.63,1.21,2.54.26,3.34-1.34,2.24-2.32-1.6-14.21-18.39-18.84-34Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.53,287a2,2,0,0,1,1,1.48c0,.56-.35.81-.86.56a2,2,0,0,1-1-1.48C206.64,287,207,286.78,207.53,287Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.36,172.45a.57.57,0,0,0-.57.05L67.71,241.25a1.79,1.79,0,0,0-.8,1.39v34.58a.56.56,0,0,0,.23.52l3.6,2.08a.57.57,0,0,0,.57-.05L190.39,211a1.79,1.79,0,0,0,.8-1.4V175.05a.56.56,0,0,0-.23-.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.31,279.77,190.39,211a1.79,1.79,0,0,0,.8-1.4V175.05c0-.52-.36-.72-.8-.47L71.31,243.33a1.79,1.79,0,0,0-.8,1.39V279.3C70.51,279.81,70.87,280,71.31,279.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.1,129a.84.84,0,0,0-.15-.26.73.73,0,0,0-.18-.17l-.09,0c-.54-.31-3.4-1.95-3.53-2a.74.74,0,0,0-.76,0L82.78,177.78a2.63,2.63,0,0,0-1,1.38L66.9,239.23l2.17,1.24,1.45.84,118.06-68.15,2.62-1.52Zm-22.61,23.82V149.1a1.77,1.77,0,0,1,.81-1.4l2.75-1.59,7.95-4.57v3.67a1.78,1.78,0,0,1-.8,1.4ZM93.14,187.61v-3.68a1.74,1.74,0,0,1,.82-1.39l2.74-1.6,8-4.57v3.7a1.78,1.78,0,0,1-.8,1.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.1,129a.84.84,0,0,0-.15-.26.73.73,0,0,0-.18-.17l-.09,0a.78.78,0,0,0-.69.06L86.4,179.88a2.33,2.33,0,0,0-1,1.36L71,239.36l-.48,1.95,118.06-68.15,2.62-1.52ZM153.49,149.1a1.77,1.77,0,0,1,.81-1.4l2.75-1.59,7.95-4.57v3.67a1.78,1.78,0,0,1-.8,1.4l-10.71,6.16ZM93.14,183.93a1.74,1.74,0,0,1,.82-1.39l2.74-1.6,8-4.57v3.7a1.78,1.78,0,0,1-.8,1.39l-10.71,6.15Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.22,175.24v6.89a1.8,1.8,0,0,1-.8,1.39L94,191.27c-.45.24-.82,0-.82-.47v-3.19l10.71-6.15a1.78,1.78,0,0,0,.8-1.39v-3.7l2.77-1.59C107.86,174.52,108.22,174.74,108.22,175.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.22,175.24v6.89a1.8,1.8,0,0,1-.8,1.39L94,191.27c-.45.24-.82,0-.82-.47v-3.19l10.71-6.15a1.78,1.78,0,0,0,.8-1.39v-3.7l2.77-1.59C107.86,174.52,108.22,174.74,108.22,175.24Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.22,175.24v6.89a1.8,1.8,0,0,1-.8,1.39L94,191.27c-.45.24-.82,0-.82-.47v-3.19l10.71-6.15a1.78,1.78,0,0,0,.8-1.39v-3.7l2.77-1.59C107.86,174.52,108.22,174.74,108.22,175.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.22,175.24v6.89a1.8,1.8,0,0,1-.8,1.39L94,191.27c-.45.24-.82,0-.82-.47v-3.19l10.71-6.15a1.78,1.78,0,0,0,.8-1.39v-3.7l2.77-1.59C107.86,174.52,108.22,174.74,108.22,175.24Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.56,140.41v6.87a1.79,1.79,0,0,1-.79,1.39l-13.47,7.76c-.44.24-.81.06-.81-.46v-3.2l10.71-6.16a1.78,1.78,0,0,0,.8-1.4v-3.67l2.77-1.6C168.21,139.68,168.56,139.9,168.56,140.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.56,140.41v6.87a1.79,1.79,0,0,1-.79,1.39l-13.47,7.76c-.44.24-.81.06-.81-.46v-3.2l10.71-6.16a1.78,1.78,0,0,0,.8-1.4v-3.67l2.77-1.6C168.21,139.68,168.56,139.9,168.56,140.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.56,140.41v6.87a1.79,1.79,0,0,1-.79,1.39l-13.47,7.76c-.44.24-.81.06-.81-.46v-3.2l10.71-6.16a1.78,1.78,0,0,0,.8-1.4v-3.67l2.77-1.6C168.21,139.68,168.56,139.9,168.56,140.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.56,140.41v6.87a1.79,1.79,0,0,1-.79,1.39l-13.47,7.76c-.44.24-.81.06-.81-.46v-3.2l10.71-6.16a1.78,1.78,0,0,0,.8-1.4v-3.67l2.77-1.6C168.21,139.68,168.56,139.9,168.56,140.41Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.26,182.58c-2.66-11.53-11.59-16-22.23-9.86l-38.34,22.14c-10.64,6.14-19.57,20.92-22.22,35.51Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.02 413.34 263.02 404.63 398.79 326.24 398.79 334.95 263.02 413.34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.02 413.34 263.02 404.63 259.25 402.45 259.25 411.16 263.02 413.34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.02 413.34 263.02 404.63 259.25 402.45 259.25 411.16 263.02 413.34",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.79 326.24 395.01 324.07 259.25 402.45 263.02 404.63 398.79 326.24",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.2 310.07 84.2 301.36 219.96 222.97 219.96 231.69 84.2 310.07",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.2 310.07 84.2 301.36 80.43 299.18 80.43 307.89 84.2 310.07",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.2 310.07 84.2 301.36 80.43 299.18 80.43 307.89 84.2 310.07",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.96 222.97 216.19 220.8 80.43 299.18 84.2 301.36 219.96 222.97",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.02 413.34 263.02 404.63 80.43 299.19 80.43 307.89 263.02 413.34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "263.02 413.34 263.02 404.63 80.43 299.19 80.43 307.89 263.02 413.34"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "263.02 413.34 263.02 404.63 266.79 402.45 266.79 411.16 263.02 413.34",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.43 299.19 84.2 297.01 266.79 402.45 263.02 404.63 80.43 299.19",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.64 400.28 285.64 382.86 89.53 269.63 89.53 287.05 285.64 400.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "285.64 400.28 285.64 382.86 89.53 269.63 89.53 287.05 285.64 400.28"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "285.64 400.28 285.64 382.86 289.42 380.68 289.42 398.1 285.64 400.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "285.64 400.28 285.64 382.86 289.42 380.68 289.42 398.1 285.64 400.28",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.53 269.63 93.31 267.45 289.42 380.68 285.64 382.86 89.53 269.63",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.81,236.34a4.34,4.34,0,0,0-.33-.56l-28.4-41a6.91,6.91,0,0,0-1.68-1.75L208.27,172.2a.62.62,0,0,0-.35-.11.28.28,0,0,0-.2.06l-.05,0c-.44.24-2.83,1.62-3.4,2l-.11.06a.25.25,0,0,0-.1.08l0,0a.69.69,0,0,0-.09.23s0,0,0,0a.22.22,0,0,0,0,.08.31.31,0,0,0,0,.1v47.68a1,1,0,0,0,.5.88L271,261.76a.58.58,0,0,0,.56.06l3.6-2.07s.06-.05.06-.09,0,0,0-.05a.32.32,0,0,0,.07-.13.93.93,0,0,0,0-.26V238A4.21,4.21,0,0,0,274.81,236.34Zm-63.35-48.56c0-.52.37-.71.81-.47L215,188.9v-3.17c0-.51.37-.7.82-.46l22.28,12.87a1.8,1.8,0,0,1,.8,1.39v10.12c0,.5-.36.73-.8.47l-2.77-1.6v3.18c0,.5-.35.72-.8.45l-2.76-1.59L215,200.87l-2.75-1.6a1.75,1.75,0,0,1-.81-1.39Zm33.59,22.34c0-.52.4-.34.88.36l2.68,3.86v-6.27c0-.51.4-.33.9.38l18.65,26.9a5.05,5.05,0,0,1,.9,2.23V241c0,.52-.41.47-.93-.11l-5-5.52,1.45,2.07a5,5,0,0,1,.89,2.22V243c0,.52-.4.46-.93-.11l-5.07-5.64-10.88-12.11L246,222.2a3.49,3.49,0,0,1-.93-2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.25,238.38a5.21,5.21,0,0,0-.34-.56l-28.39-41a6.76,6.76,0,0,0-1.69-1.75l-36.12-20.85a.71.71,0,0,0-.35-.11h-.09l-.11,0-.06,0,0,.06,0,0a.69.69,0,0,0-.09.23s0,0,0,0a.22.22,0,0,0,0,.08v47.77a1,1,0,0,0,.51.89L271,261.74c.27.16.52.14.65,0a0,0,0,0,0,0,0,.61.61,0,0,0,.07-.14,1.56,1.56,0,0,0,0-.26V240A4.21,4.21,0,0,0,271.25,238.38Zm-35.9-26.68c0,.5-.35.72-.8.45l-2.76-1.59L215,200.87l-2.75-1.6a1.75,1.75,0,0,1-.81-1.39v-10.1c0-.52.37-.71.81-.47L215,188.9l19.53,11.29a1.75,1.75,0,0,1,.8,1.39ZM265.49,243c0,.52-.4.46-.93-.11l-5.07-5.64-10.88-12.11L246,222.2a3.49,3.49,0,0,1-.93-2V210.12c0-.52.4-.34.88.36l2.68,3.86,14.54,21,1.45,2.07a5,5,0,0,1,.89,2.22Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.49,239.62V243c0,.52-.4.46-.93-.11l-5.07-5.64-10.88-12.11L246,222.2a3.49,3.49,0,0,1-.93-2V210.12c0-.52.4-.34.88.36l2.68,3.86v3.85a3.51,3.51,0,0,0,.93,2l2.64,2.94,10.87,12.1.1.13,1.45,2.07A5,5,0,0,1,265.49,239.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.49,239.62V243c0,.52-.4.46-.93-.11l-5.07-5.64-10.88-12.11L246,222.2a3.49,3.49,0,0,1-.93-2V210.12c0-.52.4-.34.88.36l2.68,3.86v3.85a3.51,3.51,0,0,0,.93,2l2.64,2.94,10.87,12.1.1.13,1.45,2.07A5,5,0,0,1,265.49,239.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.35,208.52v3.18c0,.5-.35.72-.8.45l-2.76-1.59L215,200.87l-2.75-1.6a1.75,1.75,0,0,1-.81-1.39v-10.1c0-.52.37-.71.81-.47L215,188.9v6.94a1.75,1.75,0,0,0,.82,1.39l2.74,1.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.35,208.52v3.18c0,.5-.35.72-.8.45l-2.76-1.59L215,200.87l-2.75-1.6a1.75,1.75,0,0,1-.81-1.39v-10.1c0-.52.37-.71.81-.47L215,188.9v6.94a1.75,1.75,0,0,0,.82,1.39l2.74,1.6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.17,271.45,344.05,250.6a2.42,2.42,0,0,0-1.69-.21L314,258.59a.84.84,0,0,0-.33.16c-.54.33-2.58,1.49-3.23,1.87l-.06,0h0l-.14.09a1.25,1.25,0,0,0-.33.25,1.27,1.27,0,0,0-.14.17,1.62,1.62,0,0,0-.1.18,1.17,1.17,0,0,0-.12.47v21.24a1.07,1.07,0,0,0,.07.39,1.71,1.71,0,0,0,.5.82.78.78,0,0,0,.24.19l66.28,38.28a.53.53,0,0,0,.55,0h0c.13-.09,3-1.74,3.55-2a.26.26,0,0,0,.14-.17.21.21,0,0,0,.08-.11,1,1,0,0,0,0-.26V272.84A1.74,1.74,0,0,0,380.17,271.45Zm-40.33-10.69v10.12a.88.88,0,0,1-.93.89l-2.63-.12v1.26a.88.88,0,0,1-.93.89l-2.64-.1L316.76,273a1,1,0,0,1-.93-1v-3.37a1.3,1.3,0,0,1,.89-1.2l2.67-.77v-.08a1.3,1.3,0,0,1,.89-1.19l18.66-5.36A.66.66,0,0,1,339.84,260.76Zm33.59,26.53c0,.52-.37.73-.82.47l-2.74-1.58v3.15c0,.52-.38.72-.82.46l-2.74-1.58L346.77,277a1.78,1.78,0,0,1-.8-1.39V265.44c0-.5.35-.73.8-.47l2.76,1.6v-3.18c0-.5.36-.72.8-.46l22.28,12.87a1.75,1.75,0,0,1,.82,1.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.6,273.49l-36.11-20.85a2.42,2.42,0,0,0-1.69-.2l-28.39,8.18-.06,0h0a.92.92,0,0,0-.26.14.66.66,0,0,0-.21.2,1.27,1.27,0,0,0-.14.17,1.62,1.62,0,0,0-.1.18,1.17,1.17,0,0,0-.12.47v21.24a1.07,1.07,0,0,0,.07.39,1.94,1.94,0,0,0,.5.82,1.46,1.46,0,0,0,.24.17l66.28,38.28a.66.66,0,0,0,.55.07h0a.28.28,0,0,0,.13-.16.31.31,0,0,0,.07-.12.71.71,0,0,0,.05-.26V274.89A1.75,1.75,0,0,0,376.6,273.49Zm-40.32-.58a.88.88,0,0,1-.93.89l-2.64-.1L316.76,273a1,1,0,0,1-.93-1v-3.37a1.3,1.3,0,0,1,.89-1.2l2.67-.77,16-4.59a.66.66,0,0,1,.9.67Zm33.59,16.42c0,.52-.38.72-.82.46l-2.74-1.58L346.77,277a1.78,1.78,0,0,1-.8-1.39V265.44c0-.5.35-.73.8-.47l2.76,1.6,19.52,11.26a1.81,1.81,0,0,1,.82,1.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.87,286.18v3.15c0,.52-.38.72-.82.46l-2.74-1.58L346.77,277a1.78,1.78,0,0,1-.8-1.39V265.44c0-.5.35-.73.8-.47l2.76,1.6v6.94a1.79,1.79,0,0,0,.8,1.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.87,286.18v3.15c0,.52-.38.72-.82.46l-2.74-1.58L346.77,277a1.78,1.78,0,0,1-.8-1.39V265.44c0-.5.35-.73.8-.47l2.76,1.6v6.94a1.79,1.79,0,0,0,.8,1.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.28,271.65v1.26a.88.88,0,0,1-.93.89l-2.64-.1L316.76,273a1,1,0,0,1-.93-1v-3.37a1.3,1.3,0,0,1,.89-1.2l2.67-.77V270a1,1,0,0,0,.93,1l15.95.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.28,271.65v1.26a.88.88,0,0,1-.93.89l-2.64-.1L316.76,273a1,1,0,0,1-.93-1v-3.37a1.3,1.3,0,0,1,.89-1.2l2.67-.77V270a1,1,0,0,0,.93,1l15.95.67Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.37,317.53a1.7,1.7,0,0,0-1-1.39L190,197a5.32,5.32,0,0,0-4.82,0L76.86,259.53a1.68,1.68,0,0,0-1,1.39v6.89a1.7,1.7,0,0,0,1,1.4L283.23,388.36a5.34,5.34,0,0,0,4.83,0l108.31-62.54a1.7,1.7,0,0,0,1-1.37C397.38,323.94,397.37,318,397.37,317.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.86,262.31,283.23,381.46a5.34,5.34,0,0,0,4.83,0l108.31-62.53c1.33-.77,1.33-2,0-2.79L190,197a5.32,5.32,0,0,0-4.82,0L76.86,259.53C75.53,260.3,75.53,261.55,76.86,262.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.36,300c0-3.38-2.2-6.75-6.66-9.33l-179-103.36c-8.88-5.13-23.28-5.13-32.16,0l-81,46.75c-4.38,2.53-6.6,5.83-6.66,9.14-.05,2.57,0,12.08,0,14.59,0,3.37,2.2,6.75,6.66,9.32l179,103.36c8.89,5.13,23.28,5.13,32.17,0l81-46.75c4.44-2.56,6.66-5.92,6.66-9.27C389.37,311.92,389.35,302.51,389.36,300Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.53,252.63,269.56,356c8.89,5.12,23.28,5.12,32.17,0l81-46.76c8.88-5.13,8.88-13.44,0-18.57l-179-103.36c-8.88-5.13-23.28-5.13-32.16,0l-81,46.75C81.65,239.19,81.65,247.5,90.53,252.63Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.56,356c8.89,5.12,23.28,5.12,32.17,0l81-46.76c8.88-5.13,8.88-13.44,0-18.57L245.56,211.49l-113,65.38Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.56,356c8.89,5.12,23.28,5.12,32.17,0l81-46.76c8.88-5.13,8.88-13.44,0-18.57L245.56,211.49l-113,65.38Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.56 211.49 132.51 276.87 149.2 286.5 262.25 221.13 245.56 211.49",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.31,301.64l-1.41.84a2.45,2.45,0,0,0-1.21,2.13v11.54L131,306.51V295a2.47,2.47,0,0,1,1.21-2.14c.39-.24.87-.52,1.41-.83-.68-.41-1.11-.95-1.11-2.79V276.87l16.67,9.64v12.35C149.19,300.7,149.62,301.23,150.31,301.64Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.64,359.84v36L147.69,316.15V304.61a2.45,2.45,0,0,1,1.21-2.13l1.41-.84c-.69-.41-1.12-.94-1.12-2.78V286.51L269.56,356A32.8,32.8,0,0,0,285.64,359.84Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.64,359.84v36L147.69,316.15V304.61a2.45,2.45,0,0,1,1.21-2.13l1.41-.84c-.69-.41-1.12-.94-1.12-2.78V286.51L269.56,356A32.8,32.8,0,0,0,285.64,359.84Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,321.46c1.59.92,2.39.4,2.39,4.49V336L285.64,395.86v-36A32.77,32.77,0,0,0,301.72,356l81-46.75c4.43-2.55,6.64-5.91,6.66-9.25v16.34A8,8,0,0,1,387,321.46Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,321.46h0l-96.79,55.78a9.08,9.08,0,0,1-9.09,0L133.63,292c-.54.31-1,.59-1.41.83a2.48,2.48,0,0,0-.94,1l149.83,86.36a9.1,9.1,0,0,0,9.07,0l99-56.79C388.84,322.05,388.11,322.12,387,321.46Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.61,211.55c.59-3.26-2.3-9-6.45-12.87l-16.69-15.45c-2.32-2.15-4.54-3.24-6.15-3.22l0,0c-4.13-.31-22.46,8.5-31.64,13.8s-29.44,18.2-33.28,24c-1.26,1.91,25.39,33.59,29.49,32.85,9.1-1.64,26.51-9.89,35.68-15.48,15-9.14,24-17,27.23-20.41A5.51,5.51,0,0,0,199.61,211.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.17,232.13l16.69,15.46c4.15,3.84,8,4.31,8.58,1s-2.3-9-6.45-12.87L113.3,220.31c-4.15-3.84-8-4.31-8.57-1.05S107,228.29,111.17,232.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.43,301.85a4.38,4.38,0,0,0-.34-.56l-28.39-41a6.91,6.91,0,0,0-1.68-1.75L93.89,237.71a.62.62,0,0,0-.35-.11.31.31,0,0,0-.2.05s0,0,0,0c-.44.24-2.83,1.61-3.4,2l-.11.06a.41.41,0,0,0-.11.07l0,.05a.69.69,0,0,0-.09.23s0,0,0,0a.22.22,0,0,0,0,.08.31.31,0,0,0,0,.1v47.68a1,1,0,0,0,.5.88l66.59,38.45a.58.58,0,0,0,.56.06l3.6-2.08s.06,0,.06-.08,0,0,0-.05A.32.32,0,0,0,161,325a.93.93,0,0,0,0-.26V303.5A4.16,4.16,0,0,0,160.43,301.85ZM97.08,253.29c0-.52.36-.71.81-.47l2.75,1.59v-3.17c0-.51.36-.7.81-.46l22.29,12.87a1.79,1.79,0,0,1,.79,1.39v10.12c0,.5-.35.73-.79.47L121,274v3.17c0,.51-.35.72-.8.46l-2.76-1.59-16.77-9.7-2.75-1.59a1.73,1.73,0,0,1-.81-1.39Zm33.58,22.34c0-.53.41-.34.89.36l2.68,3.86v-6.27c0-.51.4-.33.89.38l18.66,26.9a5,5,0,0,1,.89,2.23v3.38c0,.52-.4.47-.93-.11l-5-5.52,1.44,2.07a4.91,4.91,0,0,1,.9,2.22v3.38c0,.52-.4.46-.93-.11l-5.07-5.64-10.88-12.12-2.64-2.93a3.55,3.55,0,0,1-.93-2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.87,303.89a5.21,5.21,0,0,0-.34-.56l-28.39-41a6.92,6.92,0,0,0-1.69-1.75L90.33,239.75a.71.71,0,0,0-.35-.11h-.09l-.11,0-.06,0,0,.05,0,.05a.69.69,0,0,0-.09.23s0,0,0,0a.22.22,0,0,0,0,.08v47.77a1,1,0,0,0,.51.89l66.58,38.43c.27.16.52.14.64,0a0,0,0,0,0,0-.05.91.91,0,0,0,.07-.14,1.56,1.56,0,0,0,0-.26V305.54A4.16,4.16,0,0,0,156.87,303.89ZM121,277.2c0,.51-.35.72-.8.46l-2.76-1.59-16.77-9.7-2.75-1.59a1.73,1.73,0,0,1-.81-1.39v-10.1c0-.52.36-.71.81-.47l2.75,1.59,19.53,11.29a1.74,1.74,0,0,1,.8,1.38Zm30.14,31.31c0,.52-.4.46-.93-.11l-5.07-5.64-10.88-12.12-2.64-2.93a3.55,3.55,0,0,1-.93-2V275.63c0-.53.41-.34.89.36l2.68,3.86,14.54,21,1.44,2.07a4.91,4.91,0,0,1,.9,2.22Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.11,305.13v3.38c0,.52-.4.46-.93-.11l-5.07-5.64-10.88-12.12-2.64-2.93a3.55,3.55,0,0,1-.93-2V275.63c0-.53.41-.34.89.36l2.68,3.86v3.85a3.51,3.51,0,0,0,.93,2l2.64,2.94,10.87,12.1.1.13,1.44,2.07A4.91,4.91,0,0,1,151.11,305.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.11,305.13v3.38c0,.52-.4.46-.93-.11l-5.07-5.64-10.88-12.12-2.64-2.93a3.55,3.55,0,0,1-.93-2V275.63c0-.53.41-.34.89.36l2.68,3.86v3.85a3.51,3.51,0,0,0,.93,2l2.64,2.94,10.87,12.1.1.13,1.44,2.07A4.91,4.91,0,0,1,151.11,305.13Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,274v3.17c0,.51-.35.72-.8.46l-2.76-1.59-16.77-9.7-2.75-1.59a1.73,1.73,0,0,1-.81-1.39v-10.1c0-.52.36-.71.81-.47l2.75,1.59v6.94a1.74,1.74,0,0,0,.81,1.39l2.75,1.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,274v3.17c0,.51-.35.72-.8.46l-2.76-1.59-16.77-9.7-2.75-1.59a1.73,1.73,0,0,1-.81-1.39v-10.1c0-.52.36-.71.81-.47l2.75,1.59v6.94a1.74,1.74,0,0,0,.81,1.39l2.75,1.6Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.79,337l-36.12-20.85a2.36,2.36,0,0,0-1.69-.21l-28.39,8.2a.84.84,0,0,0-.33.16c-.55.33-2.58,1.49-3.23,1.87,0,0,0,0-.06,0h0l-.14.09a1.25,1.25,0,0,0-.33.25c0,.05-.1.1-.14.16l-.1.19a1,1,0,0,0-.12.47v21.23a1.34,1.34,0,0,0,.06.4,1.81,1.81,0,0,0,.51.82.78.78,0,0,0,.24.19l66.28,38.28a.57.57,0,0,0,.54.05h0c.14-.09,3.05-1.74,3.56-2.05a.22.22,0,0,0,.14-.16.23.23,0,0,0,.07-.11.67.67,0,0,0,0-.26V338.35A1.74,1.74,0,0,0,265.79,337Zm-40.33-10.69v10.12a.87.87,0,0,1-.93.88l-2.63-.11v1.26a.88.88,0,0,1-.93.89l-2.64-.1-16-.67a1,1,0,0,1-.93-1v-3.38a1.3,1.3,0,0,1,.89-1.19l2.67-.77v-.08a1.29,1.29,0,0,1,.89-1.19l18.66-5.36A.66.66,0,0,1,225.46,326.27Zm33.59,26.52c0,.53-.37.73-.82.47l-2.75-1.57v3.15c0,.52-.37.72-.81.46l-2.75-1.58-19.54-11.27a1.75,1.75,0,0,1-.79-1.38V331c0-.51.34-.73.79-.47l2.77,1.59V328.9c0-.5.36-.72.79-.46l22.29,12.87a1.75,1.75,0,0,1,.82,1.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.22,339l-36.11-20.85a2.48,2.48,0,0,0-1.69-.21L196,326.13s0,0-.06,0h0a.72.72,0,0,0-.26.14.66.66,0,0,0-.21.2c0,.05-.1.1-.14.16l-.1.19a1,1,0,0,0-.12.47v21.23a1.34,1.34,0,0,0,.06.4,2.06,2.06,0,0,0,.51.82,1.46,1.46,0,0,0,.24.17l66.28,38.28a.64.64,0,0,0,.54.07h0a.26.26,0,0,0,.14-.17A.23.23,0,0,0,263,388a1,1,0,0,0,0-.26V340.4A1.75,1.75,0,0,0,262.22,339Zm-40.32-.58a.88.88,0,0,1-.93.89l-2.64-.1-16-.67a1,1,0,0,1-.93-1v-3.38a1.3,1.3,0,0,1,.89-1.19l2.67-.77,16-4.59a.66.66,0,0,1,.9.66Zm33.58,16.42c0,.52-.37.72-.81.46l-2.75-1.58-19.54-11.27a1.75,1.75,0,0,1-.79-1.38V331c0-.51.34-.73.79-.47l2.77,1.59,19.52,11.27a1.8,1.8,0,0,1,.81,1.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.48,351.69v3.15c0,.52-.37.72-.81.46l-2.75-1.58-19.54-11.27a1.75,1.75,0,0,1-.79-1.38V331c0-.51.34-.73.79-.47l2.77,1.59V339a1.81,1.81,0,0,0,.79,1.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.48,351.69v3.15c0,.52-.37.72-.81.46l-2.75-1.58-19.54-11.27a1.75,1.75,0,0,1-.79-1.38V331c0-.51.34-.73.79-.47l2.77,1.59V339a1.81,1.81,0,0,0,.79,1.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.9,337.16v1.26a.88.88,0,0,1-.93.89l-2.64-.1-16-.67a1,1,0,0,1-.93-1v-3.38a1.3,1.3,0,0,1,.89-1.19l2.67-.77v3.3a1,1,0,0,0,.93,1l15.95.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.9,337.16v1.26a.88.88,0,0,1-.93.89l-2.64-.1-16-.67a1,1,0,0,1-.93-1v-3.38a1.3,1.3,0,0,1,.89-1.19l2.67-.77v3.3a1,1,0,0,0,.93,1l15.95.67Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.49,315.67a.58.58,0,0,0-.57.06L282.85,384.48a1.76,1.76,0,0,0-.81,1.39v15.56a.56.56,0,0,0,.23.52l3.61,2.08a.55.55,0,0,0,.57,0l119.07-68.75a1.77,1.77,0,0,0,.81-1.39V318.27a.57.57,0,0,0-.24-.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.45,404l119.07-68.75a1.77,1.77,0,0,0,.81-1.39V318.27c0-.51-.36-.72-.81-.46L286.45,386.56a1.76,1.76,0,0,0-.81,1.39v15.56C285.64,404,286,404.23,286.45,404Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.24,272.17a1.35,1.35,0,0,0-.15-.26.74.74,0,0,0-.19-.16l-.09,0c-.54-.32-3.4-1.95-3.53-2a.74.74,0,0,0-.76,0L297.91,321a2.6,2.6,0,0,0-1,1.37L282,382.45l2.17,1.25,1.45.83,118.06-68.14,2.62-1.53ZM368.62,296v-3.68a1.74,1.74,0,0,1,.82-1.39l2.75-1.6,7.94-4.57v3.68a1.79,1.79,0,0,1-.79,1.39Zm-60.35,34.83v-3.67a1.77,1.77,0,0,1,.82-1.4l2.75-1.59,8-4.57v3.69a1.81,1.81,0,0,1-.8,1.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.24,272.17a1.35,1.35,0,0,0-.15-.26.74.74,0,0,0-.19-.16l-.09,0a.78.78,0,0,0-.69.06l-88.59,51.34a2.35,2.35,0,0,0-1,1.35l-14.37,58.12-.48,1.95,118.06-68.14,2.62-1.53Zm-22.62,20.15a1.74,1.74,0,0,1,.82-1.39l2.75-1.6,7.94-4.57v3.68a1.79,1.79,0,0,1-.79,1.39L368.62,296Zm-60.35,34.84a1.77,1.77,0,0,1,.82-1.4l2.75-1.59,8-4.57v3.69a1.81,1.81,0,0,1-.8,1.4l-10.72,6.14Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.35,318.47v6.89a1.78,1.78,0,0,1-.8,1.39l-13.46,7.74c-.45.24-.82.06-.82-.46v-3.2L319,324.69a1.81,1.81,0,0,0,.8-1.4V319.6l2.76-1.6C323,317.74,323.35,318,323.35,318.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.35,318.47v6.89a1.78,1.78,0,0,1-.8,1.39l-13.46,7.74c-.45.24-.82.06-.82-.46v-3.2L319,324.69a1.81,1.81,0,0,0,.8-1.4V319.6l2.76-1.6C323,317.74,323.35,318,323.35,318.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.35,318.47v6.89a1.78,1.78,0,0,1-.8,1.39l-13.46,7.74c-.45.24-.82.06-.82-.46v-3.2L319,324.69a1.81,1.81,0,0,0,.8-1.4V319.6l2.76-1.6C323,317.74,323.35,318,323.35,318.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.35,318.47v6.89a1.78,1.78,0,0,1-.8,1.39l-13.46,7.74c-.45.24-.82.06-.82-.46v-3.2L319,324.69a1.81,1.81,0,0,0,.8-1.4V319.6l2.76-1.6C323,317.74,323.35,318,323.35,318.47Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.7,283.63v6.87a1.78,1.78,0,0,1-.8,1.39l-13.46,7.77c-.45.24-.82,0-.82-.47V296l10.72-6.17a1.79,1.79,0,0,0,.79-1.39v-3.68l2.77-1.59C383.35,282.91,383.7,283.13,383.7,283.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.7,283.63v6.87a1.78,1.78,0,0,1-.8,1.39l-13.46,7.77c-.45.24-.82,0-.82-.47V296l10.72-6.17a1.79,1.79,0,0,0,.79-1.39v-3.68l2.77-1.59C383.35,282.91,383.7,283.13,383.7,283.63Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.7,283.63v6.87a1.78,1.78,0,0,1-.8,1.39l-13.46,7.77c-.45.24-.82,0-.82-.47V296l10.72-6.17a1.79,1.79,0,0,0,.79-1.39v-3.68l2.77-1.59C383.35,282.91,383.7,283.13,383.7,283.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.7,283.63v6.87a1.78,1.78,0,0,1-.8,1.39l-13.46,7.77c-.45.24-.82,0-.82-.47V296l10.72-6.17a1.79,1.79,0,0,0,.79-1.39v-3.68l2.77-1.59C383.35,282.91,383.7,283.13,383.7,283.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.39,325.81c-2.65-11.54-11.58-16-22.22-9.86l-38.35,22.13c-10.63,6.15-19.56,20.92-22.22,35.52Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M255.54,230.7c-1.57-.34-3.21-.5-4.76-.9-1.07-.28-2.12-.67-3.18-1-.32-.09-2.48-.73-2.35-1.62s3.29.1,6.7-.45,3.71-3,1.88-3.23A32.88,32.88,0,0,1,244.2,221c-3.52-1.5-9.42,0-12.11-.83-3.39-1-20-9.23-20-9.23s-9.82-11.44-15.53-16.9c-6.18-5.91-8.19-7.93-14.28-9a41.76,41.76,0,0,0-7.46-.41l9.81,21.57s5.2,5.33,9.81,10.35c4.94,5.38,5.2,6.55,10.77,8.4,6.25,2.07,25.61,7.72,25.61,7.72,2.87,1.64,5.33,4.17,8.51,5a32.92,32.92,0,0,0,4.41.82,7.83,7.83,0,0,0,3.87-.2,18.34,18.34,0,0,1,1.92-.85c.62-.13,1.29,0,1.92-.12,1.71-.27,2.54-1.23,3.61-2.43.78-.88,2-1.05,2.89-1.75C260,231.66,256.71,231,255.54,230.7Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.57,183.92c5.83,0,10.22.8,13.4,3s9.2,7.92,13.37,12.1,5,5.28,5,5.28,0,3.33-5.16,8.22-7.56,4.94-7.56,4.94l-19.1-18.1Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.57,183.92c5.83,0,10.22.8,13.4,3s9.2,7.92,13.37,12.1,5,5.28,5,5.28,0,3.33-5.16,8.22-7.56,4.94-7.56,4.94l-19.1-18.1Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.4,200.11a.87.87,0,1,0,.86.87A.87.87,0,0,0,182.4,200.11Zm-3-10a.87.87,0,1,0,.86.87A.87.87,0,0,0,179.41,190.07Zm0,7a.87.87,0,1,0,.86.87A.87.87,0,0,0,179.41,197.1Zm3-11.06a.87.87,0,1,0,.86.87A.87.87,0,0,0,182.4,186Zm4,18.1a.87.87,0,1,0,.87.86A.87.87,0,0,0,186.44,204.14Zm-10.87-18v1.65a.87.87,0,0,0,.66-.83A.86.86,0,0,0,175.57,186.09Zm6.83,7a.87.87,0,1,0,.86.86A.87.87,0,0,0,182.4,193.08Zm18.11,5.76a.85.85,0,0,0,.84-.77l-.95-.94a.85.85,0,0,0-.76.84A.87.87,0,0,0,200.51,198.84Zm-7-7a.87.87,0,0,0,.77-.48l-1.24-1.1a.86.86,0,0,0,.47,1.58Zm-7,5.29a.87.87,0,1,0,.87.87A.87.87,0,0,0,186.44,197.1Zm17.05,4.75a.86.86,0,0,0,.85-.77l-.93-1a.85.85,0,0,0-.78.85A.87.87,0,0,0,203.49,201.85Zm-14.06-14.07a.78.78,0,0,0,.45-.15L189,187l-.37-.22a.58.58,0,0,0,0,.18A.87.87,0,0,0,189.43,187.78Zm-13.86,5.34v1.65a.85.85,0,0,0,0-1.65Zm3.84-8.35a.87.87,0,0,0,.82-.63c-.54-.06-1.1-.1-1.67-.13A.85.85,0,0,0,179.41,184.77Zm17.05,10a.86.86,0,0,0,.83-.67l-1.08-1a.86.86,0,0,0,.25,1.68Zm0,5.3a.87.87,0,1,0,.87.87A.87.87,0,0,0,196.46,200.11Zm0,14.07a.87.87,0,1,0,.87.86A.87.87,0,0,0,196.46,214.18Zm0-7a.87.87,0,1,0,.87.87A.87.87,0,0,0,196.46,207.14Zm4,4a.87.87,0,1,0,.86.87A.87.87,0,0,0,200.51,211.17Zm6.76-7a.87.87,0,0,0-.6.81.85.85,0,0,0,.41.72,5.2,5.2,0,0,0,.31-1.39Zm-3.78,2.95a.87.87,0,1,0,.87.87A.87.87,0,0,0,203.49,207.14Zm-3-3a.87.87,0,1,0,.86.86A.87.87,0,0,0,200.51,204.14Zm-11.08-11.06a.87.87,0,1,0,.87.86A.87.87,0,0,0,189.43,193.08Zm0,7a.87.87,0,1,0,.87.87A.87.87,0,0,0,189.43,200.11Zm0,7a.87.87,0,1,0,.87.87A.87.87,0,0,0,189.43,207.14Zm-3-17.07a.87.87,0,1,0,.87.87A.87.87,0,0,0,186.44,190.07Zm7,7a.87.87,0,1,0,.87.87A.87.87,0,0,0,193.47,197.1Zm0,7a.87.87,0,1,0,.87.86A.87.87,0,0,0,193.47,204.14Zm0,7a.87.87,0,1,0,.87.87A.87.87,0,0,0,193.47,211.17Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.33,234l-12.77-8-3.88-11.22c3.85-5.74,3.78-13.27-.3-18.14-3.9-4.64-11.23-9.11-18.81-12.73h0s-10.81.92-15.63,2.44a95.13,95.13,0,0,0-12.62,5.82c-4.57,3-3.76,16.64-1.44,34.6,1.1,8.5,1.65,30.26,17.93,39,0,0,15.63-11.88,26.12-18.1C200.24,241.56,211.33,234,211.33,234Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.33,234l-12.77-8-3.88-11.22c3.85-5.74,3.78-13.27-.3-18.14-3.9-4.64-11.23-9.11-18.81-12.73h0s-10.81.92-15.63,2.44a95.13,95.13,0,0,0-12.62,5.82c-4.57,3-3.76,16.64-1.44,34.6,1.1,8.5,1.65,30.26,17.93,39,0,0,15.63-11.88,26.12-18.1C200.24,241.56,211.33,234,211.33,234Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.3,263.41a.87.87,0,0,0-.68.34c.45.34.92.66,1.41,1a.94.94,0,0,0,.13-.44A.87.87,0,0,0,161.3,263.41Zm0-21.1a.87.87,0,1,0,.86.87A.87.87,0,0,0,161.3,242.31Zm0,14.07a.87.87,0,1,0,.86.86A.87.87,0,0,0,161.3,256.38Zm0-56.27a.87.87,0,1,0,.86.87A.87.87,0,0,0,161.3,200.11Zm0,35.17a.87.87,0,1,0,.86.86A.87.87,0,0,0,161.3,235.28Zm7-14.07a.87.87,0,1,0,.87.87A.87.87,0,0,0,168.33,221.21Zm-7-14.07a.87.87,0,1,0,.86.87A.87.87,0,0,0,161.3,207.14Zm0,21.1a.87.87,0,1,0,.86.87A.87.87,0,0,0,161.3,228.24Zm0-7a.87.87,0,1,0,.86.87A.87.87,0,0,0,161.3,221.21Zm0,28.13a.87.87,0,1,0,.86.87A.87.87,0,0,0,161.3,249.34Zm-3-59.27a.87.87,0,1,0,.86.87A.87.87,0,0,0,158.31,190.07Zm0,35.17a.87.87,0,1,0,.86.86A.87.87,0,0,0,158.31,225.24Zm0-7a.87.87,0,1,0,.86.87A.87.87,0,0,0,158.31,218.2Zm0,21.1a.87.87,0,1,0,.86.87A.87.87,0,0,0,158.31,239.3Zm0-7a.87.87,0,1,0,.86.87A.87.87,0,0,0,158.31,232.27Zm0-35.17a.87.87,0,1,0,.86.87A.87.87,0,0,0,158.31,197.1Zm0,7a.87.87,0,1,0,.86.86A.87.87,0,0,0,158.31,204.14Zm0,7a.87.87,0,1,0,.86.87A.87.87,0,0,0,158.31,211.17Zm10,17.07a.87.87,0,1,0,.87.87A.87.87,0,0,0,168.33,228.24Zm-3-38.17a.87.87,0,1,0,.87.87A.87.87,0,0,0,165.34,190.07Zm0,21.1a.87.87,0,1,0,.87.87A.87.87,0,0,0,165.34,211.17Zm0-14.07a.87.87,0,1,0,.87.87A.87.87,0,0,0,165.34,197.1Zm0,7a.87.87,0,1,0,.87.86A.87.87,0,0,0,165.34,204.14Zm3,52.24a.87.87,0,1,0,.87.86A.87.87,0,0,0,168.33,256.38Zm0-7a.87.87,0,1,0,.87.87A.87.87,0,0,0,168.33,249.34Zm0-14.06a.87.87,0,1,0,.87.86A.87.87,0,0,0,168.33,235.28Zm-10,11.06a.87.87,0,1,0,.86.86A.87.87,0,0,0,158.31,246.34Zm10-4a.87.87,0,1,0,.87.87A.87.87,0,0,0,168.33,242.31Zm-3,4a.87.87,0,1,0,.87.86A.87.87,0,0,0,165.34,246.34Zm0,7a.87.87,0,1,0,.87.87A.87.87,0,0,0,165.34,253.37Zm0,7a.87.87,0,1,0,.87.87A.87.87,0,0,0,165.34,260.4Zm-4-74.36a.87.87,0,1,0,.86.87A.87.87,0,0,0,161.3,186Zm0,7a.87.87,0,1,0,.86.86A.87.87,0,0,0,161.3,193.08Zm4,32.16a.87.87,0,1,0,.87.86A.87.87,0,0,0,165.34,225.24Zm0,14.06a.87.87,0,1,0,.87.87A.87.87,0,0,0,165.34,239.3Zm0-21.1a.87.87,0,1,0,.87.87A.87.87,0,0,0,165.34,218.2Zm0,14.07a.87.87,0,1,0,.87.87A.87.87,0,0,0,165.34,232.27Zm-4-18.09a.87.87,0,1,0,.86.86A.87.87,0,0,0,161.3,214.18Zm-14.07,14.06a.87.87,0,1,0,.87.87A.87.87,0,0,0,147.23,228.24Zm-3-24.1a.78.78,0,0,0-.22,0q0,.81,0,1.65a.78.78,0,0,0,.22,0,.87.87,0,1,0,0-1.73Zm3,17.07a.87.87,0,1,0,.87.87A.87.87,0,0,0,147.23,221.21Zm-2.6-24c-.11.5-.2,1-.28,1.61a.87.87,0,0,0,.76-.85A.86.86,0,0,0,144.63,197.21Zm2.6,38.07a.86.86,0,0,0-.36.08c.08.53.16,1.08.24,1.63l.12,0a.87.87,0,1,0,0-1.73Zm4,11.06a.87.87,0,1,0,.87.86A.87.87,0,0,0,151.27,246.34Zm-4-32.16a.87.87,0,1,0,.87.86A.87.87,0,0,0,147.23,214.18Zm0-21.1a.87.87,0,1,0,.87.86A.87.87,0,0,0,147.23,193.08Zm0,14.06a.87.87,0,1,0,.87.87A.87.87,0,0,0,147.23,207.14Zm0-7a.87.87,0,1,0,.87.87A.87.87,0,0,0,147.23,200.11Zm49.23,1.74a.82.82,0,0,0,.51-.19,12.32,12.32,0,0,0-.53-1.55.88.88,0,0,0-.85.87A.87.87,0,0,0,196.46,201.85Zm0,7a.89.89,0,0,0,.8-.52l.06-.38a.87.87,0,1,0-.86.9Zm0,14.07a.86.86,0,0,0,.82-.64l-.32-.92a.8.8,0,0,0-.5-.18.87.87,0,1,0,0,1.74Zm7,7a.87.87,0,0,0,.73-.42l-1.45-.9a.85.85,0,0,0-.14.45A.87.87,0,0,0,203.49,230Zm-21.09-42.2a.87.87,0,0,0,.36-.09l-1.21-.69A.86.86,0,0,0,182.4,187.78ZM145,219.46a.81.81,0,0,0,.11-.39.86.86,0,0,0-.21-.54C144.93,218.84,145,219.15,145,219.46Zm-.75-8.29q.06.84.12,1.71a.86.86,0,0,0,.74-.84A.88.88,0,0,0,144.25,211.17Zm14.06,42.2a.87.87,0,1,0,.86.87A.87.87,0,0,0,158.31,253.37Zm14.06-68.6a.85.85,0,0,0,.82-.62l-1.57.17A.88.88,0,0,0,172.37,184.77Zm-18.11,64.57a.87.87,0,1,0,.87.87A.87.87,0,0,0,154.26,249.34Zm0-28.13a.87.87,0,1,0,.87.87A.87.87,0,0,0,154.26,221.21Zm0,7a.87.87,0,1,0,.87.87A.87.87,0,0,0,154.26,228.24Zm0,14.07a.87.87,0,1,0,.87.87A.87.87,0,0,0,154.26,242.31Zm0-7a.87.87,0,1,0,.87.86A.87.87,0,0,0,154.26,235.28Zm0-42.2a.87.87,0,1,0,.87.86A.87.87,0,0,0,154.26,193.08Zm4.05,67.32a.88.88,0,0,0-.83.64c.36.36.72.71,1.09,1a.84.84,0,0,0,.6-.81A.87.87,0,0,0,158.31,260.4Zm-7-21.1a.87.87,0,1,0,.87.87A.87.87,0,0,0,151.27,239.3Zm3-32.16a.87.87,0,1,0,.87.87A.87.87,0,0,0,154.26,207.14Zm0-7a.87.87,0,1,0,.87.87A.87.87,0,0,0,154.26,200.11Zm-3,18.09a.87.87,0,1,0,.87.87A.87.87,0,0,0,151.27,218.2Zm0,7a.87.87,0,1,0,.87.86A.87.87,0,0,0,151.27,225.24Zm0,7a.87.87,0,1,0,.87.87A.87.87,0,0,0,151.27,232.27Zm3,24.11a.83.83,0,0,0-.42.12c.31.48.63.94,1,1.4a.86.86,0,0,0,.32-.66A.87.87,0,0,0,154.26,256.38Zm-3-45.21a.87.87,0,1,0,.87.87A.87.87,0,0,0,151.27,211.17Zm0-7a.87.87,0,1,0,.87.86A.87.87,0,0,0,151.27,204.14Zm.06-14.06-.77.39a.86.86,0,0,0-.16.47.87.87,0,1,0,.93-.86Zm-.06,7a.87.87,0,1,0,.87.87A.87.87,0,0,0,151.27,197.1Zm3,17.08a.87.87,0,1,0,.87.86A.87.87,0,0,0,154.26,214.18Zm32.18-10a.87.87,0,1,0,.87.86A.87.87,0,0,0,186.44,204.14Zm0,7a.87.87,0,1,0,.87.87A.87.87,0,0,0,186.44,211.17Zm0-14.07a.87.87,0,1,0,.87.87A.87.87,0,0,0,186.44,197.1Zm0,21.1a.87.87,0,1,0,.87.87A.87.87,0,0,0,186.44,218.2Zm3,17.08a.87.87,0,1,0,.87.86A.87.87,0,0,0,189.43,235.28Zm-3-10a.87.87,0,1,0,.87.86A.87.87,0,0,0,186.44,225.24Zm3,3a.87.87,0,1,0,.87.87A.87.87,0,0,0,189.43,228.24Zm-2.75-38.12a1,1,0,0,0-.24-.05.87.87,0,1,0,.87.87.85.85,0,0,0-.2-.53Zm2.75,52.19a.87.87,0,1,0,.87.87A.87.87,0,0,0,189.43,242.31Zm-3-10a.87.87,0,1,0,.87.87A.87.87,0,0,0,186.44,232.27Zm-4-11.06a.87.87,0,1,0,.86.87A.87.87,0,0,0,182.4,221.21Zm0-7a.87.87,0,1,0,.86.86A.87.87,0,0,0,182.4,214.18Zm0-7a.87.87,0,1,0,.86.87A.87.87,0,0,0,182.4,207.14Zm0,21.1a.87.87,0,1,0,.86.87A.87.87,0,0,0,182.4,228.24Zm0-28.13a.87.87,0,1,0,.86.87A.87.87,0,0,0,182.4,200.11Zm4,46.23a.87.87,0,1,0,.87.86A.87.87,0,0,0,186.44,246.34Zm0-7a.87.87,0,1,0,.87.87A.87.87,0,0,0,186.44,239.3Zm3-18.09a.87.87,0,1,0,.87.87A.87.87,0,0,0,189.43,221.21Zm-7-28.13a.87.87,0,1,0,.86.86A.87.87,0,0,0,182.4,193.08Zm0,42.2a.87.87,0,1,0,.86.86A.87.87,0,0,0,182.4,235.28Zm14.06,7a.87.87,0,0,0-.87.87.88.88,0,0,0,.47.76l1.26-.79A.86.86,0,0,0,196.46,242.31Zm-3-38.17a.87.87,0,1,0,.87.86A.87.87,0,0,0,193.47,204.14Zm-4,10a.87.87,0,1,0,.87.86A.87.87,0,0,0,189.43,214.18Zm4-17.08a.87.87,0,1,0,.87.87A.87.87,0,0,0,193.47,197.1Zm3,38.18a.87.87,0,1,0,.87.86A.87.87,0,0,0,196.46,235.28Zm7,0a.87.87,0,1,0,.87.86A.87.87,0,0,0,203.49,235.28Zm4-3a.87.87,0,1,0,.87.87A.87.87,0,0,0,207.54,232.27Zm-7,7a.87.87,0,1,0,0,1.74,1,1,0,0,0,.22,0l.44-.28a.85.85,0,0,0,.2-.54A.87.87,0,0,0,200.51,239.3Zm0-7a.87.87,0,1,0,.86.87A.87.87,0,0,0,200.51,232.27Zm-4-4a.87.87,0,1,0,.87.87A.87.87,0,0,0,196.46,228.24Zm-7-35.16a.87.87,0,1,0,.87.86A.87.87,0,0,0,189.43,193.08Zm4,46.22a.87.87,0,1,0,.87.87A.87.87,0,0,0,193.47,239.3Zm-4-39.19a.87.87,0,1,0,.87.87A.87.87,0,0,0,189.43,200.11Zm0,7a.87.87,0,1,0,.87.87A.87.87,0,0,0,189.43,207.14Zm4,4a.87.87,0,1,0,.87.87A.87.87,0,0,0,193.47,211.17Zm0,21.1a.87.87,0,1,0,.87.87A.87.87,0,0,0,193.47,232.27Zm-25.14-18.09a.87.87,0,1,0,.87.86A.87.87,0,0,0,168.33,214.18Zm25.14,11.06a.87.87,0,1,0,.87.86A.87.87,0,0,0,193.47,225.24Zm0-7a.87.87,0,1,0,.87.87A.87.87,0,0,0,193.47,218.2Zm-21.1-14.06a.87.87,0,1,0,.87.86A.87.87,0,0,0,172.37,204.14Zm0,7a.87.87,0,1,0,.87.87A.87.87,0,0,0,172.37,211.17Zm0-14.07a.87.87,0,1,0,.87.87A.87.87,0,0,0,172.37,197.1Zm0,28.14a.87.87,0,1,0,.87.86A.87.87,0,0,0,172.37,225.24Zm0-7a.87.87,0,1,0,.87.87A.87.87,0,0,0,172.37,218.2Zm10,24.11a.87.87,0,1,0,.86.87A.87.87,0,0,0,182.4,242.31Zm-10-52.24a.87.87,0,1,0,.87.87A.87.87,0,0,0,172.37,190.07Zm3,59.27a.87.87,0,1,0,.87.87A.87.87,0,0,0,175.36,249.34Zm0,7a.85.85,0,0,0-.66,1.41l1.39-1A.85.85,0,0,0,175.36,256.38Zm-7-56.27a.87.87,0,1,0,.87.87A.87.87,0,0,0,168.33,200.11Zm7,35.17a.87.87,0,1,0,.87.86A.87.87,0,0,0,175.36,235.28Zm-7-42.2a.87.87,0,1,0,.87.86A.87.87,0,0,0,168.33,193.08Zm0-7a.87.87,0,1,0,.87.87A.87.87,0,0,0,168.33,186Zm0,21.1a.87.87,0,1,0,.87.87A.87.87,0,0,0,168.33,207.14Zm4,46.23a.87.87,0,1,0,.87.87A.87.87,0,0,0,172.37,253.37Zm0-21.1a.87.87,0,1,0,.87.87A.87.87,0,0,0,172.37,232.27Zm0,7a.87.87,0,1,0,.87.87A.87.87,0,0,0,172.37,239.3Zm0,7a.87.87,0,1,0,.87.86A.87.87,0,0,0,172.37,246.34Zm3-4a.87.87,0,1,0,.87.87A.87.87,0,0,0,175.36,242.31Zm4-3a.87.87,0,1,0,.86.87A.87.87,0,0,0,179.41,239.3Zm0-21.1a.87.87,0,1,0,.86.87A.87.87,0,0,0,179.41,218.2Zm0-7a.87.87,0,1,0,.86.87A.87.87,0,0,0,179.41,211.17Zm0,21.1a.87.87,0,1,0,.86.87A.87.87,0,0,0,179.41,232.27Zm0-7a.87.87,0,1,0,.86.86A.87.87,0,0,0,179.41,225.24Zm0-21.1a.87.87,0,1,0,.86.86A.87.87,0,0,0,179.41,204.14Zm0-14.07a.87.87,0,1,0,.86.87A.87.87,0,0,0,179.41,190.07Zm-4,38.17a.87.87,0,1,0,.87.87A.87.87,0,0,0,175.36,228.24Zm4-31.14a.87.87,0,1,0,.86.87A.87.87,0,0,0,179.41,197.1Zm3,52.24a.87.87,0,1,0,.86.87A.87.87,0,0,0,182.4,249.34Zm-7-35.16a.87.87,0,1,0,.87.86A.87.87,0,0,0,175.36,214.18Zm0-7a.87.87,0,1,0,.87.87A.87.87,0,0,0,175.36,207.14Zm0-7a.87.87,0,1,0,.87.87A.87.87,0,0,0,175.36,200.11Zm0,21.1a.87.87,0,1,0,.87.87A.87.87,0,0,0,175.36,221.21Zm4,25.13a.87.87,0,1,0,.86.86A.87.87,0,0,0,179.41,246.34Zm0,7a.87.87,0,0,0-.87.87.85.85,0,0,0,.31.65l1.36-.94A.85.85,0,0,0,179.41,253.37Zm-4-67.33a.87.87,0,1,0,.87.87A.87.87,0,0,0,175.36,186Zm0,7a.87.87,0,1,0,.87.86A.87.87,0,0,0,175.36,193.08Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.24,219.1c-4.67,4.87-14.13,6.14-19.73.28,0,0,1.56,6,9.84,5.93S180.24,219.1,180.24,219.1Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.24,219.1c-4.67,4.87-14.13,6.14-19.73.28,0,0,1.56,6,9.84,5.93S180.24,219.1,180.24,219.1Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Face--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.41,182.47a10.16,10.16,0,0,1-4.25-.72,7,7,0,0,1-2.63-1.61,3.4,3.4,0,0,1-1-2.85,2.29,2.29,0,0,0-1.28,3.05,4.29,4.29,0,0,1-1.46-5.82,4.85,4.85,0,0,1-4.46-1c.93.63,2.27-.33,2.39-1.44a4,4,0,0,0-1.34-2.95,9.39,9.39,0,0,1-2.08-2.6,4.48,4.48,0,0,1,1.94-5.22,3.22,3.22,0,0,1-3.68-1.76,2.15,2.15,0,0,0,3-1.35c.23-1-.34-2-.51-3.07a5.16,5.16,0,0,1,1.47-4.24,10.34,10.34,0,0,1,3.92-2.42c1.61-.62,3.35-1.07,4.61-2.23.66-.61,1.14-1.38,1.74-2a8.21,8.21,0,0,1,7.19-2.44,23.69,23.69,0,0,0,3.29.84c2,.19,3.95-.72,5.94-.59a5.67,5.67,0,0,1,3,1.12c1.05.78,1.83,1.92,3,2.51a10.12,10.12,0,0,0,2.43.7,9.64,9.64,0,0,1,4.9,2.66,6,6,0,0,1,1.56,5.22c-.14.58-.38,1.14-.51,1.73a2.38,2.38,0,0,0,.19,1.76,1.22,1.22,0,0,0,1.56.48,1.68,1.68,0,0,1-1.32,1.18,4.91,4.91,0,0,1-1.87,0,4.37,4.37,0,0,1-3.54,5.54,2.71,2.71,0,0,0-1.39.43,17.28,17.28,0,0,0-1.65,1.55l-6.28,5.94q-3.27,3.1-6.61,6.15C161.91,180.65,160,182.28,157.41,182.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.27,151c2.38,1,7.15,4.52,7.69,17.72.41,9.94-2.64,12.32-4.14,13.24a12.58,12.58,0,0,1-6.89,1.48V187s7.1,4,2.17,6.5c-2.42,1.22-8.13.38-11.53-1-4.73-1.93-5.51-4.19-5.51-4.19l0-12.53s-1.54,1.72-4.47.16c-3.15-1.68-3.67-6-2.22-8.33a4.41,4.41,0,0,1,4.44-2.08,4.22,4.22,0,0,1,2.28,1.33c.83.84,1.41,1.74.67,3a1.85,1.85,0,0,0,2.12,2.63c-1.15-.66-.61-1.59,0-2.06,1-.72,2.1-1.42,1.93-2.83-.16-1.25-1.57-1.88-1.13-3.16.92-2.68,3.8-4.33,6.35-5.16C171.64,157.51,174.71,153.92,174.27,151Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.93,183.46c-3.23,0-11.36-2-12.61-7.21a6.81,6.81,0,0,0,2.54,5.71c3.23,2.82,10.07,3.36,10.07,3.36Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,165.77a1.47,1.47,0,0,1-1.22,1.71,1.52,1.52,0,1,1,1.22-1.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.35,164.69a1.47,1.47,0,1,1-1.63-1.35A1.49,1.49,0,0,1,179.35,164.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.76,162.91l2.75-2.55a1.8,1.8,0,0,1,0,2.61A2,2,0,0,1,164.76,162.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.32,160.74l-3.53-1.23a1.8,1.8,0,0,0,1.08,2.38A2,2,0,0,0,180.32,160.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.01 163.9 174.25 172.58 178.93 170.62 173.01 163.9",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.18,175.37v0c0-.16-.26-.3-.39-.39a4.26,4.26,0,0,0-3-.71,4.54,4.54,0,0,0-.81.19c-.1,0-.31.17-.15.26a2,2,0,0,0,.6,0,5.61,5.61,0,0,1,1.17,0,7.13,7.13,0,0,1,2.18.7C173.94,175.51,174.22,175.6,174.18,175.37Z",
    style: {
      fill: "#9a4a4d"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M211,231.6c-4.89-1.66-12-1.71-21,2.14s-19.25,10.76-26,18.46-6.59,10.91-11.73,13.33l17,9.47c5.14-3,5-5.63,11.73-13.33s17-14.62,26-18.46,16.06-3.8,20.95-2.14h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,243.16a65.78,65.78,0,0,0-9.89,9c-4.68,5.36-6,8.55-8.17,10.8,4.89,2.46,10.85,5.44,17.44,8.71,1.88-2.21,3.37-5.07,7.71-10a66.35,66.35,0,0,1,10.41-9.43C185.78,249.32,179.92,246.28,174,243.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.43,275.9c-2.94-1.86-23.59,2.17-31.28-1.52S228,241.06,228,241.06h0c-4.88-1.66-12-1.7-20.94,2.14s-19.25,10.76-26,18.46-6.6,10.28-11.53,13.21l-.22.12,90.2,51.69,38.61-18.51c4.52-.65,20.2-16.24,23.61-18.85S327.38,277.76,324.43,275.9Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.43,275.9c-2.94-1.86-23.59,2.17-31.28-1.52S228,241.06,228,241.06h0c-4.88-1.66-12-1.7-20.94,2.14s-19.25,10.76-26,18.46-6.6,10.28-11.53,13.21l-.22.12,90.2,51.69,38.61-18.51c4.52-.65,20.2-16.24,23.61-18.85S327.38,277.76,324.43,275.9Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.13,308.18c3-.9,5.36-3.2,7.78-5.08s4.72-4.1,7-6.21l6.9-6.35a12.6,12.6,0,0,0,5.06-7.41c.48-2.06,1.25-5.86-1-7-3-.7-7.24-.07-10.35,0-6.27.27-12.62.94-18.82-.62a25.59,25.59,0,0,1-4.33-2l-4.17-2.15c-19-9.76-39.44-20.3-58.24-30.3q16.83,8.28,33.56,16.75c5.64,2.85,19.66,10,25.08,12.72l4.18,2.13c4.06,2.5,8.64,2.89,13.35,2.88,4.49,0,9.51-.34,14-.53a21.18,21.18,0,0,1,6,.33c2.88,1.39,2,5.51,1.41,8a13.3,13.3,0,0,1-5.36,7.68l-7,6.24c-2.35,2.06-4.73,4.1-7.18,6s-4.9,4.08-7.93,4.9Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.06,290.3c-8.72-.47-24.78,1.84-43-7.06-11.8-5.76-35.37-17.07-62.56-31a66.35,66.35,0,0,0-10.41,9.43c-4.34,5-5.83,7.83-7.72,10,24.3,12.06,56.92,27.93,74.2,35,24.55,10,37.95,3.6,48.78-2.65C306.7,298.05,306.26,290.8,297.06,290.3Z",
    style: {
      fill: "#845EC2",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.22,236c-2.36.26-4.68.73-7,1.13a34,34,0,0,1-7.26.54c-.1,0-.24-.05-.23-.15s0-.08.08-.12a26.15,26.15,0,0,0,2.73-2.3,3.26,3.26,0,0,0,.81-3.29.43.43,0,0,0-.14-.21c-.19-.18-.5-.09-.74,0-.74.35-1.34.85-2.1,1.15a18.2,18.2,0,0,1-2.37.77,29.27,29.27,0,0,0-2.94.71,10.6,10.6,0,0,0-3.48,2.24,6.31,6.31,0,0,1-3,1.72c-2.51.61-4.61.59-10.05-.11-8.52-1.11-13.06-1.89-13.06-1.89l.24-20.9c0-11.62-2.76-20.31-6-22.34-2.88,1.6-6.41,4.4-7.82,6.56-2.5,3.85-2.88,6.59-3.08,18.7-.14,8.06-.4,13.05-.17,20.3.36,11.29,1.37,11.9,11.39,12.67a113.36,113.36,0,0,0,19.58-.63h0c2.33-.21,17.33-.42,19.79-1a10,10,0,0,0,5.55-3.11c.36-.41.68-.85,1-1.27a3.26,3.26,0,0,1,.93-.92c.3-.16.63-.28.93-.46a2.8,2.8,0,0,0,1.3-2c.19-1.18,1.45-1.55,2.41-1.92a59.57,59.57,0,0,0,6-2.47.28.28,0,0,0,.12-.12.37.37,0,0,0,0-.18C204.31,235.73,202.3,235.88,201.22,236Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.48,236.23c-3.91-.3-9.37.72-11.63,2.88,0,0,1.39-4.13,11.65-4.73Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.32,192.18c-6.33,3.27-9.1,5.77-11,11.14s-1.81,12.24-2.07,19.48S134,231,134,231a20,20,0,0,0,10.09,2.72c7-.17,9.81-2.56,9.81-2.56s.62-17.25,0-24.22S150.53,193.73,147.32,192.18Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.32,192.18c-6.33,3.27-9.1,5.77-11,11.14s-1.81,12.24-2.07,19.48S134,231,134,231a20,20,0,0,0,10.09,2.72c7-.17,9.81-2.56,9.81-2.56s.62-17.25,0-24.22S150.53,193.73,147.32,192.18Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.2,214.18a.87.87,0,1,0,.86.86A.87.87,0,0,0,140.2,214.18Zm0-7a.87.87,0,1,0,.86.87A.87.87,0,0,0,140.2,207.14Zm0,14.07a.87.87,0,1,0,.86.87A.87.87,0,0,0,140.2,221.21Zm4,11.06a.87.87,0,0,0-.87.87.85.85,0,0,0,.26.61h.42l.82,0a.84.84,0,0,0,.24-.58A.87.87,0,0,0,144.24,232.27Zm0-7a.87.87,0,1,0,.87.86A.87.87,0,0,0,144.24,225.24Zm-4-25.13a.87.87,0,1,0,.86.87A.87.87,0,0,0,140.2,200.11Zm0,28.13a.87.87,0,1,0,.86.87A.87.87,0,0,0,140.2,228.24Zm4-10a.87.87,0,1,0,.87.87A.87.87,0,0,0,144.24,218.2Zm9.89-2.31V214.2a.86.86,0,0,0-.74.84A.87.87,0,0,0,154.13,215.89Zm-.15-7.07c0-.56-.06-1.09-.1-1.58a.85.85,0,0,0,.1,1.58Zm-2.71-10a.87.87,0,0,0,.68-.34c-.19-.48-.39-.94-.59-1.38l-.09,0a.87.87,0,0,0,0,1.74Zm-14.06,33.43a.8.8,0,0,0-.43.13c.38.14.79.29,1.23.43A.85.85,0,0,0,137.21,232.27Zm0-21.1a.87.87,0,1,0,.86.87A.87.87,0,0,0,137.21,211.17Zm0-7a.87.87,0,1,0,.86.86A.87.87,0,0,0,137.21,204.14Zm0,14.06a.87.87,0,1,0,.86.87A.87.87,0,0,0,137.21,218.2Zm0,7a.87.87,0,1,0,.86.86A.87.87,0,0,0,137.21,225.24Zm14.06,0a.87.87,0,1,0,.87.86A.87.87,0,0,0,151.27,225.24Zm0-7a.87.87,0,1,0,.87.87A.87.87,0,0,0,151.27,218.2Zm-.79,14.6c.44-.14.84-.28,1.19-.42a.88.88,0,0,0-.4-.11A.85.85,0,0,0,150.48,232.8Zm.79-21.63a.87.87,0,1,0,.87.87A.87.87,0,0,0,151.27,211.17Zm2.12,17.94a.85.85,0,0,0,.51.78c0-.43,0-1,0-1.58A.85.85,0,0,0,153.39,229.11Zm-2.12-25a.87.87,0,1,0,.87.86A.87.87,0,0,0,151.27,204.14Zm2.12,17.94a.87.87,0,0,0,.68.83c0-.55,0-1.1,0-1.67A.87.87,0,0,0,153.39,222.08Zm-6.16-29a.87.87,0,1,0,.87.86A.87.87,0,0,0,147.23,193.08Zm0,35.16a.87.87,0,1,0,.87.87A.87.87,0,0,0,147.23,228.24Zm-3-31.14a.87.87,0,1,0,.87.87A.87.87,0,0,0,144.24,197.1Zm0,7a.87.87,0,1,0,.87.86A.87.87,0,0,0,144.24,204.14Zm0,7a.87.87,0,1,0,.87.87A.87.87,0,0,0,144.24,211.17Zm3-11.06a.87.87,0,1,0,.87.87A.87.87,0,0,0,147.23,200.11Zm0,7a.87.87,0,1,0,.87.87A.87.87,0,0,0,147.23,207.14Zm0,7a.87.87,0,1,0,.87.86A.87.87,0,0,0,147.23,214.18Zm0,7a.87.87,0,1,0,.87.87A.87.87,0,0,0,147.23,221.21Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--table--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.12,326.88V421l-2.21-1.27-9.27-5.34v-91.6a.45.45,0,0,1,0-.18s0-.05.06-.09,0-.05.05-.07,2.12-1.22,2.21-1.27a.35.35,0,0,1,.35,0l1.72,1,6.56,3.79A1.07,1.07,0,0,1,218.12,326.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.91,328.16v91.6l-9.27-5.34v-91.6a.45.45,0,0,1,0-.18s0-.05.06-.09.23-.12.4,0l1.72,1,6.56,3.79A1.07,1.07,0,0,1,215.91,328.16Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.85,323.52l-1.72-1c-.17-.08-.32-.07-.4,0s-.06.05-.06.09a.45.45,0,0,0,0,.18v4.86l9.27,5.35v-4.87a1.07,1.07,0,0,0-.5-.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.22,305.14a1.63,1.63,0,0,1,.95-1.33l135.09-78.12a5,5,0,0,1,4.6,0l44.24,25.55a1.61,1.61,0,0,1,.95,1.33v6.57a1.59,1.59,0,0,1-.95,1.32L238,338.59a5.08,5.08,0,0,1-4.59,0L189.17,313a1.63,1.63,0,0,1-.95-1.31C188.21,311.25,188.22,305.62,188.22,305.14Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.1,253.9,238,332a5,5,0,0,1-4.59,0l-44.25-25.55c-1.27-.73-1.27-1.92,0-2.66l135.09-78.12a5,5,0,0,1,4.6,0l44.24,25.55C374.37,252,374.37,253.16,373.1,253.9Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.71,331.69a3.86,3.86,0,0,1-1.85-.43L189.61,305.7c-.37-.21-.51-.44-.51-.56s.14-.34.51-.56L324.7,226.45a3.9,3.9,0,0,1,1.86-.43,3.86,3.86,0,0,1,1.85.43L372.66,252c.38.22.51.44.51.56s-.13.34-.51.56L237.57,331.26A3.9,3.9,0,0,1,235.71,331.69Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.71,331.69a3.86,3.86,0,0,1-1.85-.43L189.61,305.7c-.37-.21-.51-.44-.51-.56s.14-.34.51-.56L324.7,226.45a3.9,3.9,0,0,1,1.86-.43,3.86,3.86,0,0,1,1.85.43L372.66,252c.38.22.51.44.51.56s-.13.34-.51.56L237.57,331.26A3.9,3.9,0,0,1,235.71,331.69Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shoes--inject-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Slippers--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.68,411.89c3.46-3.9,7.21-5.06,13-7.51s9.19-5.34,12.95-7.27c3.18-1.63,6.21-2.42,9.88-.64,2,1,2.86,2.13,2.86,3.37,0,.37,0,1.86,0,2.24-.05,1.38-1.13,2.86-2.86,4.3-3.34,2.79-8.54,4.23-10.95,6.91S152.7,421,144.79,421c-6.42,0-12-2-12-4.87V414A3.18,3.18,0,0,1,133.68,411.89Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.51,396.47c4.28,2.08,3.34,5,0,7.8s-8.54,4.23-10.95,6.9-5.86,7.69-13.77,7.69-14.56-3.07-11.11-7,7.21-5.06,13-7.51,9.19-5.34,12.95-7.27C162.81,395.48,165.84,394.69,169.51,396.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.93,402.6c1.56-5.14,6.79-6.28,11.42-7.67s7.14-4.39,12-6.32,9.91-2.47,13.51,0c1.28.88,1.79,1.69,1.75,2.48,0,.33,0,1.73,0,2.08,0,1.12-1.18,2.17-2.85,3.25-3.35,2.18-8.35,4.14-12.59,7.48s-8.24,7-13.11,8.07c-5.09,1.1-10.28-2.16-10.25-6,0-.33,0-1.83,0-2.27A4.6,4.6,0,0,1,109.93,402.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.82,388.61c-3.6-2.47-8.68-1.93-13.51,0s-7.33,4.93-12,6.32-9.86,2.53-11.42,7.67c-1.31,4.37,4.45,8.47,10.08,7.25,4.87-1.05,8.87-4.72,13.11-8.06s9.24-5.31,12.59-7.48C148.53,392.48,149.9,390.73,146.82,388.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.59,402.41c.4-7.11-7-12.71-11.42-10.29-5.77,3.19-9.22,5.88-9.69,8.77a9,9,0,0,0,.06,4.44,8.7,8.7,0,0,0,9.43,3.85C125.49,408.1,129.05,404.2,131.59,402.41Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.43,412.63c.41-7.11-7.65-12.95-12.08-10.54-5.76,3.19-10.37,6.07-10.84,9s-.3,3.25-.21,3.46c1.49,2.63,7.61,4.14,13.25,3.61S154.45,414.74,156.43,412.63Z",
    style: {
      fill: "#845EC2"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--serum-bag--inject-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--blood-bag--inject-28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.83,371.11a3.88,3.88,0,0,1-.09.87,2,2,0,0,1-.78,1.21h0a2.28,2.28,0,0,1-2.4-.18,7.3,7.3,0,0,1-3.3-5.72,2.35,2.35,0,0,1,.93-2.09h0l.16-.1h0a2.07,2.07,0,0,1,1.4-.05,3.31,3.31,0,0,1,.81.35A7.27,7.27,0,0,1,76.83,371.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.93,364a3,3,0,0,0-1.47-.45,1.74,1.74,0,0,0-.93.26l-.08.05-2.13,1.22a2.07,2.07,0,0,1,1.4-.05,3.31,3.31,0,0,1,.81.35,7.27,7.27,0,0,1,3.3,5.71,3.88,3.88,0,0,1-.09.87,2,2,0,0,1-.78,1.21l2.19-1.27,0,0,.19-.11a.1.1,0,0,0,0,0,2.4,2.4,0,0,0,.81-2A7.25,7.25,0,0,0,75.93,364Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.12,351.91a3.79,3.79,0,0,1-.09.86,2,2,0,0,1-.78,1.21l0,0a2.3,2.3,0,0,1-2.4-.18,7.31,7.31,0,0,1-3.3-5.72,2.35,2.35,0,0,1,.93-2.1h0l.16-.09h0a2.07,2.07,0,0,1,1.4,0,3.48,3.48,0,0,1,.81.35A7.27,7.27,0,0,1,41.12,351.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.22,344.81a3.08,3.08,0,0,0-1.47-.44,1.74,1.74,0,0,0-.93.26l-.08,0-2.13,1.23a2.07,2.07,0,0,1,1.4,0,3.48,3.48,0,0,1,.81.35,7.27,7.27,0,0,1,3.3,5.71,3.79,3.79,0,0,1-.09.86,2,2,0,0,1-.78,1.21l2.19-1.26,0,0,.19-.11a.1.1,0,0,0,.05,0,2.41,2.41,0,0,0,.81-2A7.29,7.29,0,0,0,40.22,344.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.49,378.61a3.76,3.76,0,0,0,.1.86,2,2,0,0,0,.78,1.21l0,0a2.26,2.26,0,0,0,2.39-.18,7.28,7.28,0,0,0,3.31-5.72,2.34,2.34,0,0,0-.93-2.09h0l-.16-.1h0a2.1,2.1,0,0,0-1.41-.05,3.48,3.48,0,0,0-.81.35A7.29,7.29,0,0,0,47.49,378.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4,371.51a3.08,3.08,0,0,1,1.47-.44,1.68,1.68,0,0,1,.92.26l.09.05L53,372.6a2.1,2.1,0,0,0-1.41-.05,3.48,3.48,0,0,0-.81.35,7.29,7.29,0,0,0-3.3,5.71,3.76,3.76,0,0,0,.1.86,2,2,0,0,0,.78,1.21l-2.19-1.26,0,0-.19-.11-.06,0a2.44,2.44,0,0,1-.81-2A7.29,7.29,0,0,1,48.4,371.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.31,367.25a3.85,3.85,0,0,0,.1.87,2,2,0,0,0,.78,1.21l0,0a2.28,2.28,0,0,0,2.4-.19,7.28,7.28,0,0,0,3.31-5.72,2.35,2.35,0,0,0-.93-2.09h0l-.15-.09h0a2,2,0,0,0-1.41-.06,4,4,0,0,0-.81.36A7.28,7.28,0,0,0,24.31,367.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.21,360.16a3.05,3.05,0,0,1,1.47-.45,1.8,1.8,0,0,1,.93.26l.09,0,2.13,1.23a2,2,0,0,0-1.41-.06,4,4,0,0,0-.81.36,7.28,7.28,0,0,0-3.3,5.7,3.85,3.85,0,0,0,.1.87,2,2,0,0,0,.78,1.21L23,368.06h0l-.18-.12s0,0-.06,0a2.45,2.45,0,0,1-.81-2A7.29,7.29,0,0,1,25.21,360.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.12,353.33a4.54,4.54,0,0,0,.09.86A2,2,0,0,0,70,355.4l0,0a2.28,2.28,0,0,0,2.4-.19,7.25,7.25,0,0,0,3.3-5.71,2.35,2.35,0,0,0-.93-2.1h0l-.15-.09h0a2,2,0,0,0-1.41-.05,3.48,3.48,0,0,0-.81.35A7.29,7.29,0,0,0,69.12,353.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70,346.23a3.11,3.11,0,0,1,1.47-.44,1.71,1.71,0,0,1,.93.26l.09,0,2.13,1.23a2,2,0,0,0-1.41-.05,3.48,3.48,0,0,0-.81.35,7.29,7.29,0,0,0-3.3,5.71,4.54,4.54,0,0,0,.09.86A2,2,0,0,0,70,355.4l-2.19-1.26,0,0-.18-.11-.06,0a2.44,2.44,0,0,1-.81-2A7.29,7.29,0,0,1,70,346.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.42 346.35 37.63 342.97 37.63 345.49 49.42 352.29 49.42 346.35",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.42 346.35 50.58 345.64 38.76 342.41 37.63 342.97 49.42 346.35",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "54.51 353.86 71.22 347.6 71.22 345.06 54.51 346.55 54.51 353.86",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "71.22 345.06 70 344.73 53.52 345.79 54.51 346.55 71.22 345.06",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,353.06c0,1.89-5.81,1.89-5.81,0V331.15H55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,330a1.26,1.26,0,0,0,0,2.38,4.58,4.58,0,0,0,4.11,0,1.26,1.26,0,0,0,0-2.38A4.58,4.58,0,0,0,50,330Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.61,348.76l-3.2,20.75h2.18l3-20.75A3.65,3.65,0,0,1,50.61,348.76Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.58 348.76 52.58 354.46 49.59 373.02 49.59 369.51 52.58 348.76",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.41,
    y: 369.51,
    width: 2.19,
    height: 3.51,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.58 354.29 75.13 365.58 75.13 362.1 53.58 348.77 53.58 354.29",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.58,348.77a2.36,2.36,0,0,0,1.38-.62L76.47,361.2l-1.35.9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.13 365.58 75.13 362.1 76.47 361.2 76.47 364.57 75.13 365.58",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.41 361.59 49.43 353.71 49.43 348.54 26.41 358.12 26.41 361.59",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.43,348.54c-.18-.05-.26-.38-.28-.89L25.73,357.83l.68.29Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25.73 357.83 25.73 361.2 26.41 361.59 26.41 358.12 25.73 357.83",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.41,
    y: 369.51,
    width: 2.19,
    height: 3.51,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.13 365.58 75.13 362.1 76.47 361.2 76.47 364.57 75.13 365.58",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25.73 357.83 25.73 361.2 26.41 361.59 26.41 358.12 25.73 357.83",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.36,92.49V330.93a.83.83,0,0,0,.49.68,2.59,2.59,0,0,0,2.39,0,.85.85,0,0,0,.5-.68V92.49a1.69,1.69,0,1,0-3.38,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.55,125.48l-1.69-1a4.45,4.45,0,0,0-4.41,0,2.33,2.33,0,0,1-2.34,0l-.93-.53a2.36,2.36,0,0,1-.83-.83l-2.68-4.46a4.43,4.43,0,0,0-1.58-1.55L50.73,106v2.4l18.32,10.58a2.28,2.28,0,0,1,.84.82l2.67,4.46a4.43,4.43,0,0,0,1.58,1.55l.93.54a4.42,4.42,0,0,0,4.42,0,2.36,2.36,0,0,1,2.33,0l1.69,1a1.06,1.06,0,0,0,.52.13,1,1,0,0,0,.52-1.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.25,155.79a15.34,15.34,0,0,0,3.65-7.39c.39-3.69-.76-14.88-1.2-19.59s-1.2-5.58-2.41-5.49-2.41.39-3.28-.59-1.53-1.94-3.5-.8-2.63,2.84-3.51,4.84a14.65,14.65,0,0,1-3.28,4.38c-1.2,1.31-2.64,3.07-3.08,8.28s-1.16,17.32-.53,21c.24,1.38,1.17,3.34,4.27,3.17.27,0,.44.24.39.64l-.12,1.13a1.13,1.13,0,0,1-.58.89l-.19.08a1.49,1.49,0,0,0-.77,1.22l-.48,5.36c0,.51.21.81.57.68l2.14-.79a1.49,1.49,0,0,0,.77-1.15l.76-5.49c.08-.56-.19-.85-.58-.73s-.44-.16-.4-.54l.09-.79a1.22,1.22,0,0,1,.76-1l.68-.23a19.57,19.57,0,0,0,3.09-1.47l.6-.36c.33-.21.6,0,.62.42l0,6.86c0,.64.34.94.92.61a1.86,1.86,0,0,0,.85-1.72l0-7.12A1.48,1.48,0,0,1,79,159c.37-.3.73-.61,1.07-.92s.68-.24.75.19l.12.79a1.14,1.14,0,0,1-.38.94l-.17.15a1.51,1.51,0,0,0-.5,1.29l.76,4.21c.07.4.4.5.73.23l2-1.63a1.53,1.53,0,0,0,.51-1.24l-.5-4.44c-.05-.46-.4-.54-.76-.27s-.48.11-.53-.2l-.18-1.22A1.51,1.51,0,0,1,82.25,155.79Zm-6.74-28.15c-.66.38-1.2,0-1.2-.91a2.86,2.86,0,0,1,1.2-2.28c.66-.39,1.19,0,1.19.9A2.87,2.87,0,0,1,75.51,127.64Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84,133.64c-.47-4.8-1-8.89-3.22-7.53s-7.22,4.35-8.77,5.06a7.91,7.91,0,0,0-3.92,4.2c-1,3.15-1.24,8-1.31,10.41s5.62-.47,9.91-2.87S84,133.64,84,133.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.46,145a.34.34,0,0,0,0,.14c-.28,4.82-.56,10.48-.7,13.19h0a3,3,0,0,0,3,3.1,12.61,12.61,0,0,0,5.81-2c6.51-3.76,8.56-8.22,8.91-9.92h0a16.73,16.73,0,0,0,.29-2.55,99.25,99.25,0,0,0-.67-13,.26.26,0,0,0-.28-.23,5.46,5.46,0,0,0-3.21,1.7c-2.11,1.93-4.25,4.56-9.26,6.86A9.14,9.14,0,0,0,67.46,145Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.46,145a.34.34,0,0,0,0,.14c-.28,4.82-.56,10.48-.7,13.19h0a3,3,0,0,0,3,3.1,12.61,12.61,0,0,0,5.81-2c6.51-3.76,8.56-8.22,8.91-9.92h0a16.73,16.73,0,0,0,.29-2.55,99.25,99.25,0,0,0-.67-13,.26.26,0,0,0-.28-.23,5.46,5.46,0,0,0-3.21,1.7c-2.11,1.93-4.25,4.56-9.26,6.86A9.14,9.14,0,0,0,67.46,145Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.65,162.93a.51.51,0,0,1-.51-.49L77,157.27a.5.5,0,0,1,.49-.52h0a.52.52,0,0,1,.51.5l.14,5.16a.52.52,0,0,1-.5.52Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.65,162.93a.51.51,0,0,1-.51-.49L77,157.27a.5.5,0,0,1,.49-.52h0a.52.52,0,0,1,.51.5l.14,5.16a.52.52,0,0,1-.5.52Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.46,145a.34.34,0,0,0,0,.14c-.28,4.82-.56,10.48-.7,13.19a3,3,0,0,0,3,3.1,12.61,12.61,0,0,0,5.81-2c6.51-3.76,8.55-8.22,8.91-9.92a16.73,16.73,0,0,0,.29-2.55c0-.37,0-.77,0-1.18-.2,4.15-5.48,9.39-10.15,10.45s-3.75-4.37-3.23-14l-.06,0A9.14,9.14,0,0,0,67.46,145Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.79,147.82a58.81,58.81,0,0,1-10.91,6.3c-.16.07-.28,0-.28-.25v-3.59a.79.79,0,0,1,.29-.59q5.44-3.49,10.88-6.28c.16-.08.29,0,.29.25v3.59A.74.74,0,0,1,81.79,147.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.73,127.74c-3.38,1.74-5.72,3.06-5.77,4s4.55-1.49,6-.28,1.44.49,1.44-.83S82.13,127,80.73,127.74Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.69,276.21c-1,0-2.1,0-3.15-.13-17.83-1.55-38.64-15.14-38.64-48.37V165.09a.75.75,0,0,1,1.5,0v62.62c0,32.21,20.07,45.38,37.27,46.87,11.75,1,24.46-4.29,30.89-12.9,3.53-4.73,6.85-12.6,2.65-23.27a.75.75,0,0,1,1.4-.55c4.45,11.31.91,19.68-2.85,24.71C141.51,271,130.12,276.21,118.69,276.21Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.69,275.71c-1,0-2.07,0-3.11-.13a40.23,40.23,0,0,1-25.74-12.33c-8.14-8.57-12.44-20.86-12.44-35.54V165.09a.25.25,0,0,1,.5,0v62.62c0,32.55,20.32,45.86,37.72,47.37,12.12,1.05,24.71-4.22,31.34-13.11,3.6-4.82,7-12.86,2.72-23.74a.25.25,0,0,1,.14-.33.25.25,0,0,1,.32.14c4.37,11.1.9,19.3-2.78,24.23C141.2,270.53,130,275.71,118.69,275.71Z",
    style: {
      fill: "#845EC2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.87 238.63 151.4 236.15 152.49 237.88 147.99 240.46 146.87 238.63",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.11,124.5a2.33,2.33,0,0,0,2.34,0,4.45,4.45,0,0,1,4.41,0l1.69,1a1,1,0,0,1-1,1.8l-1.69-1a2.36,2.36,0,0,0-2.33,0,4.42,4.42,0,0,1-4.42,0",
    style: {
      fill: "#455a64"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientDetail);
export default __webpack_public_path__ + "static/media/PatientDetail.0af39830b816b7279ddf94412dd22ca1.svg";
export { ForwardRef as ReactComponent };